import { Box, Container, Link, List, ListItem, Typography } from '@mui/material';
import { ENV } from 'src/global-config';

export function TermsAndConditionsArabic({ sx, ...other }) {
  const env = ENV;
  const url = env === 'prod' ? 'https://www.shahen-sa.com' : 'https://shahen-sa.com/EnhancedUI';
  return (
    <Box
      component="section"
      sx={[
        {
          pb: 10,
          pt: { xs: 3, md: 10 },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        <Box>
          <Box display="flex" justifyContent="around">
            <Box>
              <Box>
                <Box sx={{ m: 5 }}>
                  <Typography
                    component="h5"
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '24px',
                      margin: '10px 40px 0px 0px',
                      textAlign: 'center',
                    }}
                  >
                    الشروط والأحكام
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>عن شحن </Typography>
                  <Typography>
                    منصة شحن، المملوكة لشركة فكر للاتصالات وتقنية المعلومات، هي شركة ذات مسؤولية
                    محدودة مسجلة في المملكة العربية السعودية تحت السجل التجاري رقم 1010582007. يقع
                    مقر الشركة الرئيسي في مدينة الرياض، السعودية. تعد "شحن" علامة تجارية مسجلة تابعة
                    لشركة فكر للاتصالات وتقنية المعلومات، ورقم تسجيل العلامة التجارية هو 1442022156.
                  </Typography>{' '}
                  <br />
                  <Typography>
                    منصة شحن هي منصة إلكترونية متطورة تهدف إلى تقديم خدمات النقل واللوجستيات عبر
                    الإنترنت، حيث تربط بين العملاء الذين يحتاجون لنقل بضائعهم وبين الناقلين الذين
                    يمتلكون الشاحنات المناسبة لتلك المهام. توفر المنصة خدمات نقل متنوعة تشمل
                    الشاحنات بجميع أنواعها، وتسعى لتقديم حلول نقل آمنة وفعالة تغطي جميع أنحاء
                    المملكة العربية السعودية.
                  </Typography>{' '}
                  <br />
                  <Typography>
                    من خلال منصة شحن، يمكن للمستخدمين طلب خدمات النقل، تتبع الشحنات، والحصول على
                    تقارير تفصيلية حول حالة الشحنات. كما تلتزم المنصة بتوفير أعلى معايير الجودة
                    والأمان في تقديم خدماتها، بما يتوافق مع اللوائح والأنظمة المعمول بها في المملكة
                    العربية السعودية.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>المقدمة</Typography>
                  <Typography>
                    تهدف منصة شحن إلى توفير حلول نقل مبتكرة وآمنة، تربط بين العملاء الباحثين عن
                    خدمات نقل البضائع والناقلين المؤهلين. من خلال هذه الشروط والأحكام، نسعى لضمان
                    تجربة استخدام سلسة وآمنة لمنصتنا، وذلك عبر تحديد الحقوق والواجبات لكافة الأطراف
                    المعنية.
                  </Typography>
                  <br />
                  <Typography>
                    نرجو منكم قراءة هذه الشروط والأحكام بعناية قبل استخدام خدماتنا، حيث أنها تشكل
                    اتفاقية قانونية ملزمة بينكم وبين منصة شحن. إن استمراركم في استخدام الموقع
                    الإلكتروني والتطبيق الخاص بمنصة شحن يعني موافقتكم الكاملة على الالتزام بكافة
                    الشروط والأحكام المبينة هنا. تحتفظ منصة شحن بحق تعديل هذه الشروط والأحكام من وقت
                    لآخر، وسيتم نشر التعديلات على الموقع الإلكتروني. إن استمراركم في استخدام الخدمات
                    بعد نشر التعديلات يعد قبولاً لتلك التعديلات.
                  </Typography>
                  <br />
                  <Typography>
                    نحن نقدر ثقتكم ونلتزم بتقديم أفضل خدمة ممكنة، ونسعى دائماً لتحسين تجربتكم معنا.
                    شكراً لاختياركم منصة شحن كشريك موثوق لتلبية احتياجات النقل واللوجستيات الخاصة
                    بكم.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>أهداف الشروط والأحكام</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, ml: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          تحديد العلاقة التعاقدية:
                        </Typography>{' '}
                        توضيح العلاقة التعاقدية بين منصة "شحن" والعميل، بما يشمل حقوق والتزامات كل
                        طرف.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          حماية حقوق الأطراف:{' '}
                        </Typography>{' '}
                        ضمان حماية حقوق جميع الأطراف المتعاقدة، بما في ذلك منصة "شحن"، العملاء،
                        والناقلين، من خلال وضع قواعد وسياسات واضحة تنظم العمليات والخدمات.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          توفير شفافية كاملة:
                        </Typography>{' '}
                        تعزيز الشفافية في جميع التعاملات بين منصة "شحن" والعملاء، بما يضمن وضوح
                        الشروط والأحكام المتعلقة بالخدمات المقدمة، الأسعار، السياسات، والرسوم.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          ضمان الاستخدام العادل والمناسب للخدمات:{' '}
                        </Typography>{' '}
                        وضع قواعد وإرشادات لاستخدام التطبيقات والمواقع الإلكترونية والخدمات التي
                        تقدمها منصة "شحن"، لضمان الاستخدام العادل والمناسب ولمنع أي إساءة استخدام.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          تحديد حدود المسؤولية:
                        </Typography>{' '}
                        تحديد حدود مسؤولية منصة "شحن" والعميل في مختلف الحالات، بما يشمل مسؤولية
                        النقل، التخزين، والتسليم، وذلك لتجنب النزاعات المحتملة.
                      </Typography>
                    </ListItem>

                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          إدارة المخاطر والتعويضات:
                        </Typography>{' '}
                        توضيح السياسات المتعلقة بالتأمين، التعويضات، والاستثناءات، لضمان إدارة فعالة
                        للمخاطر وحماية مصالح جميع الأطراف.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          تنظيم العمليات المالية:
                        </Typography>{' '}
                        تحديد السياسات المالية المتعلقة بالرسوم، الدفع، والإلغاء، لضمان عملية مالية
                        سلسة وفعالة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          توفير سبل حل النزاعات:
                        </Typography>{' '}
                        وضع آليات واضحة وفعالة لحل النزاعات بين الأطراف، بما في ذلك التحكيم أو
                        اللجوء إلى الجهات القضائية، لضمان حل النزاعات بطرق عادلة وسريعة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          الامتثال للقوانين واللوائح:
                        </Typography>{' '}
                        ضمان الامتثال لجميع القوانين واللوائح المحلية والدولية المتعلقة بالنقل
                        والخدمات اللوجستية، بما يعزز المصداقية والموثوقية لمنصة "شحن".
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          تحقيق رضا العملاء:
                        </Typography>{' '}
                        العمل على تحقيق أعلى مستويات رضا العملاء من خلال تقديم خدمات ذات جودة عالية،
                        وتوفير إرشادات وسياسات واضحة تساعد العملاء في الاستفادة المثلى من خدمات منصة
                        "شحن".
                      </Typography>
                    </ListItem>
                  </List>
                  {/* <!--------------- Use of Information Related Policies --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>تعريفات</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, ml: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          منصة شحن:
                        </Typography>{' '}
                        تشير إلى منصة شحن، العلامة التجارية المسجلة لشركة فكر للاتصالات وتقنية
                        المعلومات، وهي شركة خاصة ذات مسؤولية محدودة تقدم خدمات النقل واللوجستيات عبر
                        منصة إلكترونية متطورة تغطي جميع أنحاء المملكة العربية السعودية.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          العميل:
                        </Typography>{' '}
                        يشير إلى الشخص أو الكيان الذي يستخدم خدمات منصة شحن لإرسال أو استلام
                        البضائع.
                      </Typography>
                    </ListItem>

                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          المفوض:
                        </Typography>{' '}
                        الشخص المخول من قبل العميل (سواء كان فرداً أو شركة) لاتخاذ القرارات والتوقيع
                        على الوثائق المتعلقة باستخدام خدمات منصة شحن نيابة عن العميل.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          الشاحنة:
                        </Typography>{' '}
                        تشير إلى جميع أنواع الشاحنات المستخدمة في عمليات النقل بما في ذلك التريلات،
                        السقس، اللواري، الدينا، والونيت، سواء كانت مبردة أو غير مبردة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          الناقل:{' '}
                        </Typography>{' '}
                        الشخص أو الشركة التي تمتلك الشاحنات وتقوم بعمليات النقل عبر منصة شحن.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          السائق:
                        </Typography>{' '}
                        السائقون التابعون للناقل، المسؤولون عن قيادة الشاحنات وتحميل وتنزيل البضائع
                        وفقًا لتعليمات منصة شحن والعميل.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          الموقع الإلكتروني:
                        </Typography>{' '}
                        يشير إلى موقع شحن على الإنترنت الذي يمكن الوصول إليه عبر{' '}
                        <Link href={url} target="_blank" rel="noopener noreferrer">
                          www.shahen-sa.com،
                        </Link>{' '}
                        ويستخدمه العملاء للحصول على معلومات حول خدمات النقل وإدارة الطلبات.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          التطبيق:
                        </Typography>{' '}
                        يشير إلى تطبيق شحن المتوفر على الهواتف الذكية، والذي يمكن العملاء من إدارة
                        طلباتهم وتتبع الشحنات والاستفادة من خدمات النقل المقدمة من منصة شحن.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          البضاعة:
                        </Typography>{' '}
                        تشير إلى جميع أنواع المنتجات أو السلع التي يتم نقلها عبر خدمات منصة شحن.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          الحمولة:
                        </Typography>{' '}
                        تشير إلى كمية أو حجم البضائع التي يتم تحميلها على الشاحنة لنقلها من مكان إلى
                        آخر.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          الشحنة:
                        </Typography>{' '}
                        تشير إلى البضائع المحملة على الشاحنة والمعدة للنقل من نقطة التحميل إلى نقطة
                        التسليم.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          التعبئة حسب المواصفات والمقاييس:
                        </Typography>{' '}
                        تشير إلى عملية تعبئة وتغليف البضائع وفقاً للمعايير والمواصفات الدولية
                        والمحلية المعتمدة لضمان سلامتها أثناء النقل.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          النقل:{' '}
                        </Typography>{' '}
                        عملية نقل البضائع من موقع التحميل إلى موقع التسليم باستخدام الشاحنات المخصصة
                        لذلك عبر خدمات منصة شحن.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          الشحن:
                        </Typography>{' '}
                        يشير إلى عملية تحميل البضائع على الشاحنات وتوصيلها إلى وجهتها النهائية عبر
                        خدمات منصة شحن.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          بوليصة الشحن:
                        </Typography>{' '}
                        الوثيقة الرسمية التي تصدرها منصة شحن أو الناقل، وتحتوي على تفاصيل الشحنة مثل
                        نوع البضاعة، الكمية، الوجهة، والمعلومات المتعلقة بالتحميل والتسليم.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          التأمين:
                        </Typography>{' '}
                        الخدمة التي توفرها منصة شحن لتغطية الأضرار أو الخسائر التي قد تلحق بالبضائع
                        أثناء النقل، وذلك وفقاً للشروط والأحكام الخاصة ببوليصة التأمين المعتمدة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          العقد:
                        </Typography>{' '}
                        الاتفاقية القانونية بين العميل ومنصة شحن، والتي تحدد شروط وأحكام استخدام
                        خدمات النقل المقدمة عبر المنصة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          الرسوم:
                        </Typography>{' '}
                        التكاليف المالية التي يتحملها العميل مقابل استخدام خدمات منصة شحن، والتي
                        تشمل رسوم الإلغاء، رسوم التأخير، رسوم المبيت، رسوم الطرق غير المعبدة، ورسوم
                        المناطق الحيوية.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          المسؤولية:
                        </Typography>{' '}
                        الالتزامات التي يتحملها العميل أو الناقل أو منصة شحن فيما يتعلق بتنفيذ
                        عمليات النقل والتعويض عن الأضرار أو الخسائر التي قد تنشأ.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          الفاتورة:
                        </Typography>{' '}
                        الوثيقة المالية التي تصدرها منصة شحن للعميل، والتي تحتوي على تفاصيل الرسوم
                        المستحقة عن الخدمات المقدمة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          التحميل:
                        </Typography>{' '}
                        عملية وضع البضائع على الشاحنة في موقع التحميل استعداداً لنقلها إلى الوجهة
                        المحددة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          التنزيل:
                        </Typography>{' '}
                        عملية تفريغ البضائع من الشاحنة في موقع التسليم.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          نقاط التحميل والتسليم:
                        </Typography>{' '}
                        المواقع الجغرافية المحددة التي يتم عندها تحميل البضائع على الشاحنة وتنزيلها
                        منها.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          فترة الانتظار:
                        </Typography>{' '}
                        الفترة الزمنية التي ينتظر فيها السائق في موقع التحميل أو التسليم بسبب تأخر
                        العميل أو عدم جاهزية البضائع أو موقع التسليم للإستلام.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          خدمة العملاء:
                        </Typography>
                        القسم المسؤول في منصة شحن عن التعامل مع استفسارات وشكاوى العملاء وتقديم
                        الدعم اللازم لهم.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          المشرف:{' '}
                        </Typography>
                        الشخص المسؤول عن متابعة عمليات النقل والتحقق من تنفيذها وفقاً للشروط
                        والأحكام المعتمدة، والتدخل في حالات الطوارئ أو النزاعات.
                      </Typography>
                    </ListItem>
                  </List>
                  {/* <!--------------- Cookies and Tracking Technologies Related Policies --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>الشروط العامة: </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>تحكم شروط الاستخدام:</Typography>
                  <Typography>
                    وصول أو استخدام الأفراد من أي دولة في العالم للتطبيقات والمواقع الإلكترونية
                    والمحتويات والمنتجات والخدمات التي توفرها منصة "شحن"، وهي علامة تجارية مملوكة
                    لشركة فكر للاتصالات وتقنية المعلومات. قراءة هذه الشروط بعناية قبل الحصول على
                    الخدمات أو استخدامها تُنشئ علاقة تعاقدية بينك وبين منصة "شحن". هذه الشروط تحل
                    محل أي اتفاقات أو ترتيبات سابقة أبرمت معك، ويجوز لشركة فكر للاتصالات وتقنية
                    المعلومات إنهاء هذه الشروط أو أي من الخدمات التي تخصك على الفور أو بشكل عام
                    إيقاف عرض الخدمات أو منع الوصول إليها أو إلى أي جزء منها في أي وقت ولأي سبب كان.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>الشروط التكميلية:</Typography>
                  <Typography>
                    قد تنطبق بعض الشروط التكميلية على خدمات معينة، كالسياسات الخاصة بحدث أو نشاط أو
                    حملة ترويجية معينة، وتسود الشروط التكميلية على هذه الشروط في حالة التعارض فيما
                    يتعلق بالخدمات المقدمة، وتعتبر جزءًا من الخدمات المقدمة. يجوز لشركة "شحن" وشركة
                    فكر للاتصالات وتقنية المعلومات تعديل الشروط المتعلقة بالخدمات من حين إلى آخر،
                    وتسري التعديلات عند نشر هذه الشروط المحدثة على هذا الموقع أو نشر السياسات
                    المعدلة المتعلقة بالخدمة المقدمة. استمرار وصولك إلى الخدمات أو استخدامها بعد هذا
                    النشر يعتبر موافقة منك على الالتزام بالشروط بصيغتها المعدلة.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>سياسة الخصوصية:</Typography>
                  <Typography>
                    وفقًا لما هو منصوص عليه في سياسة الخصوصية، نقوم بجمع البيانات الشخصية واستخدامها
                    فيما يتعلق بالخدمات المقدمة لك. يجوز لشركة "شحن" وشركة فكر للاتصالات وتقنية
                    المعلومات تقديم ما يلزم من المعلومات (بما في ذلك معلومات الاتصال الخاصة بك) إلى
                    شركات تسوية المطالبات أو شركات التأمين في حالة وجود شكوى أو نزاع أو خلاف بينك
                    وبين مقدم خدمات خارجي (بما في ذلك الناقل). تكون هذه المعلومات أو البيانات ضرورية
                    لتسوية الشكوى أو النزاع أو الخلاف. تحتفظ شركة "شحن" بحق استخدام بعض بيانات
                    العميل غير السرية، مثل الأسماء والشعارات، في سياق الترويج والتسويق لخدماتها بشكل
                    غير مباشر، بما يساهم في تعزيز الثقة المتبادلة مع العملاء وتطوير الخدمات المقدمة،
                    بشرط مراعاة الحفاظ على السرية لتلك البيانات غير المعلنة وعدم المساس بحقوق
                    الملكية الفكرية.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>مسؤوليات العميل:</Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    تقديم المعلومات الصحيحة:
                  </Typography>
                  <Typography>
                    يجب أن تكون مسؤولية العميل أو من ينوب عنه تزويد الشركة بقائمة أي أصناف مخفية أو
                    مخالفة أو ضد القوانين المعمول بها وكذلك الأصناف الخطرة والمضرة التي قد يسبب
                    تواجدها خسائر أو أضرار أو قد تتسبب في أخطار للناس أو الممتلكات بما في ذلك حياة
                    الفريق الذي يتولى نقلها. في هذه الحالة، سيكون العميل مسؤولا عن كافة المصاريف
                    التي يتم تكبدها نتيجة للخسارة أو التلف من قبل الشركة بسبب عدم الكشف عنها أو
                    الإخفاء المتعمد لأي من المعلومات أو البيانات المتعلقة بهذا النوع من
                    الأصناف/البضائع/الشحنة.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>استلام البضاعة:</Typography>
                  <Typography>
                    إذا تخلف العميل عن استلام البضاعة في المكان والزمان المتفق عليهما، فإنه سيكون
                    مسؤولاً عن كافة المصاريف المتعلقة بالتأخير، بما في ذلك مصاريف المبيت أو أية رسوم
                    إضافية، والتي سيتم احتسابها حسب تعريفة الشركة. يجب على العميل استلام البضاعة
                    خلال فترة لا تتجاوز (48) ساعة من تاريخ وصول الشاحنة إلى موقع التسليم، وبعد هذه
                    المدة لن تكون الشركة مسؤولة عن أي أضرار قد تحدث للبضاعة أو تلفها أو ضياعها.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>تعذر التسليم:</Typography>
                  <Typography>
                    في حال تعذر تسليم البضاعة لأي سبب من الأسباب، مثل عدم تمكن شركة "شحن" من التواصل
                    مع العميل، أو رفض أو تجاهل العميل استلام البضاعة، يبقى العميل مسؤولاً عن أية
                    تكاليف و/أو رسوم و/أو مصاريف تنتج عن إرجاع أو إتلاف البضاعة، أو أي رسوم إضافية
                    أخرى تنتج من هذه الشروط والأحكام.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>التأخير والإشعار:</Typography>
                  <Typography>
                    يجب على العميل إشعار شركة "شحن" كتابيًا إذا كان يرغب بتأخير التسليم وتخزين
                    البضاعة في الشاحنة قبل رفع الطلب. في حال عدم إشعار الشركة بذلك، يتحمل العميل
                    كافة المسؤوليات المالية والقانونية الناتجة عن ذلك، وتبقى الشركة غير مسؤولة عن أي
                    أضرار قد تحدث للبضاعة نتيجة لهذا التأخير.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    مسؤولية العميل تجاه الجهات الحكومية:{' '}
                  </Typography>
                  <Typography>
                    إذا تم رفض الشحنة أو حجزها أو مصادرتها من قبل الجهات الحكومية، فإن شركة "شحن"
                    غير مسؤولة عن تعويض العميل أو التدخل في تخليص البضاعة أو مراجعة الجهات الحكومية.
                    تُعتبر هذه المسؤولية على عاتق العميل، بما في ذلك دفع جميع الأجور والمصاريف
                    المترتبة على ذلك.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>تسليم الرمز:</Typography>
                  <Typography>
                    يجب على العميل أقفال الطلب من خلاله أو تقديم رمز التحقق للناقل بعد تنزيل البضائع
                    خلال 30 دقيقة. في حال عدم تقديم الرمز في الوقت المحدد، سيتم إغلاق الطلب تلقائيًا
                    دون أي مسؤولية على منصة "شحن".
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>إعداد بوليصة الشحن:</Typography>
                  <Typography>
                    في حال قام المرسل بإعداد بوليصة الشحن بنفسه، فإنه يتحمل المسؤولية الكاملة عن دقة
                    البيانات والمعلومات المدرجة فيها. أما إذا قامت شركة "شحن" بإعداد بوليصة الشحن
                    نيابةً عنه، فإن المرسل يتحمل مسؤولية تقديم البيانات الصحيحة لضمان إعداد بوليصة
                    الشحن بشكل دقيق.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>البيانات غير الصحيحة:</Typography>
                  <Typography>
                    {' '}
                    إذا كانت البيانات المقدمة غير صحيحة، مثل عناوين التسليم أو معلومات المرسل إليه،
                    فإن العميل يتحمل جميع التكاليف التي قد تنشأ عن ذلك. في حال تغيير العنوان، فإن أي
                    رسوم إضافية يطلبها الناقل بسبب تغيير العنوان ستكون على عاتق العميل بالكامل. منصة
                    "شحن" غير مسؤولة عن أي رسوم إضافية يفرضها الناقل في مثل هذه الحالات.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    التوقيع على وثيقة الشحن:
                  </Typography>
                  <Typography>
                    يلتزم كل من المرسل والمرسل إليه بالتوقيع بشكل واضح على وثيقة الشحن، ويجوز
                    استخدام أي وسيلة مناسبة تراها منصة شحن بدلاً عن التوقيع، كالتحقق من خلال الوسائل
                    التقنية أو أي وسيلة إثبات أخرى تراها منصة شحن مناسبة.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>تفتيش الشحنة:</Typography>
                  <Typography>
                    يقبل المستفيد بأن لمنصة شحن فتح الشحنة ومعاينتها وفحصها في أي وقت أثناء النقل
                    دون إشعار مسبق وتُعد موافقة المستفيد على هذه الشروط والأحكام بمثابة الموافقة على
                    ذلك.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    الاتفاق المباشر مع ناقل:
                  </Typography>
                  <Typography>
                    منصة شحن غير مسؤولة عن أي اتفاق يتم بطريق مباشر بين العميل والناقل أو تابعيه دون
                    موافقة خطية مسبقة من منصة شحن. أي اتفاق أو تبعات تنشأ عن ذلك تعتبر مسؤولية
                    العميل بالكامل، ويعُد ذلك انتهاكًا لحقوق منصة شحن.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>الرسوم والمخالفات:</Typography>
                  <Typography>
                    يتحمل العميل دفع أي رسوم ومخالفات يكون سببها سوء التحميل أو عدم اتباع الأنظمة في
                    مسألة الوزن المسموح للتحميل بحسب أنظمة المرور والجهات الحكومية، وأي تكاليف يكون
                    العميل سببها.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    سياسات الدفع والتعاملات المالية:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, ml: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يتحمل العميل مسؤولية دفع جميع الرسوم والتكاليف المترتبة على الخدمة، بما في ذلك
                      رسوم التحميل والتنزيل، رسوم التأخير، رسوم المبيت، ورسوم الطرق غير المعبدة
                      والمناطق الحيوية.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      تتعدد الرسوم المفروضة وقد تطبق أكثر من رسم على رحلة واحدة. يتم فوترة هذه
                      الرسوم إما ضمن فاتورة الطلب نفسها أو عبر فاتورة خارجية أخرى، ويجب على العميل
                      سدادها وفقًا للسياسات المعتمدة من قبل منصة شحن.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      لا يجوز للعميل التفاوض حول الرسوم أو تأخير سدادها. تمتلك منصة شحن الحق باتخاذ
                      الإجراءات المناسبة لحماية حقوقها وحقوق ناقليها، بما في ذلك إيقاف تسليم الحمولة
                      حتى يتم دفع الرسوم. كما أن منصة شحن غير مسؤولة عن أي تعطيل أو تأخير يحدث نتيجة
                      لتأخير العميل في سداد الرسوم وما قد يترتب عليه من رسوم إضافية أخرى.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      يمنع دفع أي مبالغ مالية مباشرة إلى الناقل أو التابعين له. أي مبالغ مالية يجب
                      أن تتم عبر الوسائل الرسمية المحددة من قبل منصة شحن لضمان الشفافية والأمان في
                      التعاملات المالية. في حال قام العميل بدفع مبالغ مالية مباشرة للناقل، فإن منصة
                      شحن غير مسؤولة عن الرحلة وتعتبر الطلب غير مدفوع. يتعين على العميل دفع الأجر
                      المتفق عليه لمنصة شحن، وللمنصة الحق في اتخاذ الإجراءات القانونية المناسبة وفق
                      سياستها. كما يحق لمنصة شحن إلغاء الطلب دون التنازل عن أتعابها وحقوقها من تلك
                      الرحلة.
                    </ListItem>
                  </List>
                  {/* <!--------------- Information Sharing and Disclosure  Related Policies --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>تحديد المسؤولية:</Typography>
                  <Typography>
                    توفر لك منصة شحن معلومات ومواد معينة على سبيل الخدمة، سواء من خلال منصة شحن أو
                    مورديها أو غير ذلك. المعلومات والمواد المقدمة على الموقع الإلكتروني أو التطبيق
                    تُقدَّم "كما هي"، ولم تجهّزَ مع مراعاة أغراض أو مواقف أو احتياجات بعينها لآحاد
                    المستخدمين، وتُقدَّم دون أي ضمانات من أي نوع، صريحة كانت أم ضمنية.
                  </Typography>
                  <Typography>
                    منصة شحن لا تقدم أي ضمانات أو تعهدات بشأن استخدام أو نتائج استخدام الموقع
                    الإلكتروني أو المواقع الإلكترونية المرتبطة أو التطبيق من حيث مدى صحتها أو دقتها
                    أو ملاءمة توقيتها أو مصداقيتها أو غير ذلك. منصة شحن غير مسؤولة عن أي أخطاء أو
                    بيانات غير صحيحة، ولا تتحمل مسؤولية تعاقدية أو تقصيرية (بما في ذلك الإهمال) أو
                    غير ذلك عن أي خسارة أو ضرر أيًا ما كانت أسبابه (بما في ذلك الخسائر أو الأضرار
                    المباشرة أو غير المباشرة أو التابعة أو الخاصة أو خسارة الربح).
                  </Typography>
                  <Typography>
                    إنك تخلي مسؤولية منصة شحن من جميع المطالبات التي تنشأ عن أي عبارة أو بيان على
                    الموقع الإلكتروني أو التطبيق الإلكتروني أو أي منصة تابعة. السبيل الوحيد والشامل
                    المتاح أمامك لجبر الضرر عن أي مما تقدم أو عن أي نزاع مع منصة شحن أو التابعين لها
                    أو مع أي من مسؤوليها أو مديريها أو موظفيها أو مساهميها أو وكلائها هو التوقف عن
                    استخدام الموقع. تتبرأ منصة شحن إلى أقصى حد يجيزه القانون المعمول به من جميع
                    المسؤوليات والالتزامات المتعلقة بالموقع الإلكتروني وتخلي مسؤوليتها عن جميع
                    الضمانات الصريحة والضمنية التي تشمل على سبيل المثال لا الحصر الضمانات الضمنية
                    المتعلقة بالقابلية للبيع والملاءمة لغرض معين.
                  </Typography>
                  <Typography>
                    لا تضمن منصة شحن عدم انقطاع الخدمات التي يشملها الموقع الإلكتروني والتطبيق أو
                    خلوها من الأخطاء أو تصحيح العيوب أو خلو الموقع الإلكتروني أو الخادم الذي يقدم
                    الموقع الإلكتروني من الفيروسات أو العناصر الضارة الأخرى. تلتزم إلى أقصى حد يجيزه
                    القانون بتعويض منصة شحن ومسؤوليها وموظفيها عن كل التكاليف والمصاريف والتعويضات
                    المتكبدة فيما يتعلق بأي دعوى يقيمها الغير ضد منصة شحن تكون ناشئة عن أي إخلال من
                    جانبك بأي من شروط الاستخدام الماثلة. إنك تقر بأن تحديد مسؤولية منصة شحن والتبرؤ
                    منها وتعويضك لها ينسحب أيضًا على جميع التابعين لمنصة شحن بمن فيهم أي شركة أم أو
                    شركة تابعة.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>التسجيل:</Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      أنواع المستخدمين:{' '}
                    </Typography>{' '}
                    يوجد نوعان من مستخدمي الموقع الإلكتروني، وهما: "عملاء بحسابات شحن" و"عملاء بدون
                    حسابات شحن". رغم أنه لا يُشترط التسجيل وإنشاء حساب، فإن التسجيل يمنحك القدرة على
                    الوصول إلى وظائف إضافية متاحة في الموقع الإلكتروني.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      التسجيل وإنشاء الحساب:
                    </Typography>{' '}
                    لكي تصبح "عميل بحساب شحن" مُسجَّل، يجب أن تقوم أنت (أو شركتك إذا كان تسجيلك في
                    الموقع الإلكتروني يتم نيابة عن الشركة التي تعمل بها) باستكمال عملية التسجيل لدى
                    منصة شحن. يتطلب ذلك تزويدنا بمعلوماتك أو بيانات ومعلومات شركتك. عدم صحة البيانات
                    المدخلة من قبل المستخدم يعرض حسابه للإيقاف. تحتفظ منصة شحن بالحق في رفض أي طلب
                    تسجيل بمحض إرادتها.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      التزامات المستخدم:
                    </Typography>{' '}
                    استكمالك لعملية التسجيل نيابة عن شركتك يعتبر تعهدًا منك بأنك تتمتع بصلاحية إلزام
                    شركتك، وبأنك تضمن امتثال أي موظف آخر من موظفي الشركة يستخدم الموقع الإلكتروني
                    لهذه الشروط والأحكام. تُضاف الشروط والأحكام الماثلة إلى شروط أي عقد تبرمه مع
                    منصة شحن بشأن حسابك.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      أمان الحساب:
                    </Typography>
                    يجب تسجيل الدخول باستخدام رقم هاتفك المحمول ورمز التحقق المرسل إلى هاتفك. يجب
                    عليك التأكد من إبقاء بيانات حسابك آمنة وسرية وعدم الإفصاح عنها لأي شخصٍ آخر. إنك
                    تقر بمسؤوليتك الكاملة عن حسابك، وبوجوب إخطار منصة شحن فور وقوع أي استخدام غير
                    مُصرَّح به لحسابك أو بوقوع أي خرق أمني آخر يتعلق بحسابك.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      مسؤولية المستخدم:
                    </Typography>{' '}
                    إنك تقر وتوافق على عدم تحمل منصة شحن أي مسؤولية عن أي خسارة أو ضرر ينجم عن
                    الاستخدام الاحتيالي لحسابك وتخلي ساحة منصة شحن من جميع المطالبات التي تنشأ عن
                    الاستخدام غير المصرح به لحسابك. كما أنك تقر بعدم تحمل منصة شحن أي مسؤولية عن
                    ضمان حداثة أي معلومات تتعلق بك أو بشركتك أو اكتمالها أو دقتها، وتوافق على أن
                    تقوم أنت بمتابعة أيّ من هذه المعلومات وتحديثها.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      إنهاء التسجيل:
                    </Typography>
                    يجوز لك أو لمنصة شحن إنهاء تسجيلك في أي وقت ولأي سببٍ دون إخطار خطي. بمجرد أن
                    يتم إنهاء تسجيلك بواسطة منصة شحن، لن تتمكن من الوصول إلى أي جزء من أجزاء الموقع
                    الإلكتروني المخصصة للمستخدمين المُسجَّلين دون موافقة مسبقة من منصة شحن.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      استخدام الموقع الإلكتروني:
                    </Typography>
                    في حال استخدامك للموقع الإلكتروني في طلب قيام منصة شحن بمهمة نيابة عنك، سنقوم
                    بإرسال بريد إلكتروني إلى العنوان الذي تقدمه أثناء عملية التسجيل لتأكيد تسلمنا
                    طلبك. رغم أن منصة شحن تبذل كل جهدٍ لضمان إمكانية الاعتماد على الخدمات المُقدَّمة
                    على الموقع الإلكتروني بقدرٍ الإمكان، إلا أن طبيعة الإنترنت تعني عدم إمكانية
                    تحميلنا المسؤولية عن طلبات لم نؤكد لك تسلمنا لها.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      إدخال البيانات :
                    </Typography>
                    يجوز لمنصة شحن الاحتفاظ بأي بيانات تقدمها أثناء استخدام الموقع الإلكتروني، وتقوم
                    بذلك طبقاً لسياسة الخصوصية الخاصة بنا. إنك تقر بأنه يجوز لمنصة شحن حذف هذه
                    البيانات في أي وقت، وتقر بأنك تتحمل المسؤولية وحدك دون غيرك عن الاحتفاظ بنسخة
                    احتياطية من هذه البيانات، وأن منصة شحن لا تتحمل أي مسؤولية عن فقدها أو حذفها.
                  </Typography>
                  {/* <!--------------- Data Security  Related Policies --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>سياسة الخصوصية </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>جمع البيانات</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    أنواع البيانات التي نجمعها:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          البيانات الشخصية:
                        </Typography>{' '}
                        تشمل الاسم، العنوان، رقم الهاتف، البريد الإلكتروني، وغيرها من المعلومات التي
                        يمكن استخدامها لتحديد هوية الشخص.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          البيانات غير الشخصية:
                        </Typography>{' '}
                        تشمل البيانات التي لا تحدد هوية الشخص بشكل مباشر، مثل معلومات الاستخدام
                        العامة، نوع الجهاز، عنوان IP، سجل التصفح، وغيرها.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>طرق جمع البيانات:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          عند التسجيل:
                        </Typography>{' '}
                        نقوم بجمع البيانات عند إنشاء حساب على منصة "شحن".
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          أثناء الاستخدام:
                        </Typography>{' '}
                        نقوم بجمع البيانات خلال استخدامك لتطبيقاتنا وخدماتنا، بما في ذلك عند تقديم
                        طلبات الشحن، التواصل مع خدمة العملاء، أو التفاعل مع محتوى الموقع.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          من أطراف ثالثة:
                        </Typography>{' '}
                        قد نحصل على بيانات من شركائنا أو مزودي الخدمات الآخرين الذين يتعاونون معنا.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>استخدام البيانات</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    الأغراض التي نستخدم البيانات من أجلها:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          تحسين الخدمات:
                        </Typography>{' '}
                        نستخدم البيانات لتقديم وتحسين خدماتنا، بما في ذلك تخصيص تجربة المستخدم
                        وتطوير الميزات الجديدة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          التواصل:
                        </Typography>{' '}
                        نستخدم البيانات للتواصل معك بخصوص حسابك، طلبات الشحن، والتحديثات المتعلقة
                        بخدماتنا.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          الأمان:{' '}
                        </Typography>{' '}
                        نستخدم البيانات للحفاظ على أمان حسابك وحماية منصتنا من الأنشطة الاحتيالية أو
                        غير القانونية.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          التسويق:
                        </Typography>{' '}
                        نستخدم البيانات لإرسال العروض الترويجية والمحتوى التسويقي الذي قد يهمك،
                        بناءً على موافقتك.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>مشاركة البيانات:</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>مشاركة المعلومات</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    يجوز لـ”منصة شحن” مشاركة معلوماتك مع أطراف أخرى لغرض تحسين الخدمة. تشمل هذه
                    الأطراف جهات حكومية وغير حكومية، وشركاء تجاريين، ومزودي خدمات آخرين. يتم ذلك
                    وفقًا للسياسات والإجراءات المعمول بها، ومع مراعاة القوانين واللوائح ذات الصلة. •
                    الحالات التي قد يتم فيها مشاركة المعلومات تشمل، على سبيل المثال لا الحصر:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      الامتثال للمتطلبات القانونية أو التنظيمية.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      تحسين تجربة المستخدم والخدمات المقدمة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>معالجة الشكاوى والنزاعات.</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      تعزيز الأمان ومنع الأنشطة الاحتيالية أو غير القانونية.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      لأغراض التسويق والدعاية والإعلان.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          مع مزودي الخدمة:
                        </Typography>{' '}
                        نشارك البيانات مع شركائنا ومزودي الخدمات الذين يساعدوننا في تقديم خدماتنا،
                        مثل شركات التأمين، الناقلين، هيئة النقل, وزارة النقل, وشركات تسوية
                        المطالبات.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          للأغراض القانونية:
                        </Typography>{' '}
                        نشارك البيانات عند الحاجة للامتثال للقوانين واللوائح، أو بناءً على طلب
                        الجهات الحكومية أو القضائية.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography>
                    بموافقتك على استخدام خدمات منصة شحن، فإنك تقر وتوافق على مشاركة بياناتك مع
                    الأطراف الثالثة المذكورة. إذا لم تكن موافقًا على مشاركة بياناتك، يجب عليك التوقف
                    فورًا عن استخدام خدمات منصة شحن وحذف التطبيق.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>حقوق العملاء</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          حق الوصول:
                        </Typography>{' '}
                        يحق لك الوصول إلى البيانات الشخصية التي نحتفظ بها عنك، وطلب نسخة منها.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          حق التصحيح:
                        </Typography>{' '}
                        يحق لك طلب تصحيح أي بيانات غير دقيقة أو غير كاملة نحتفظ بها.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          حق الحذف:
                        </Typography>{' '}
                        يحق لك طلب حذف بياناتك الشخصية من سجلاتنا، ما لم يكن هناك سبب قانوني أو
                        تشغيلي يمنعنا من ذلك.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          حق الاعتراض:
                        </Typography>{' '}
                        يحق لك الاعتراض على معالجة بياناتك في بعض الحالات، مثل استخدامها لأغراض
                        التسويق المباشر.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          حق نقل البيانات:
                        </Typography>{' '}
                        يحق لك طلب نقل بياناتك الشخصية إلى جهة أخرى بناءً على طلبك.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>سرية المعلومات</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          تدابير الأمان:
                        </Typography>{' '}
                        نلتزم باتخاذ جميع التدابير الأمنية المعقولة لحماية بياناتك الشخصية من الوصول
                        غير المصرح به، التعديل، الإفشاء، أو التدمير.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          تقييد الوصول:
                        </Typography>{' '}
                        نقتصر الوصول إلى بياناتك الشخصية على الموظفين والشركاء الذين يحتاجون إلى تلك
                        البيانات لتقديم الخدمات المتفق عليها.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          تخزين البيانات:
                        </Typography>{' '}
                        نحتفظ ببياناتك الشخصية فقط للمدة اللازمة لتحقيق الأغراض التي جُمعت من أجلها،
                        أو كما يتطلبه القانون.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          إجراءات الطوارئ:
                        </Typography>{' '}
                        نمتلك خططًا للطوارئ والاستجابة الفورية لحالات الاختراقات الأمنية أو حوادث
                        البيانات.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>
                    ملفات تعريف الارتباط (الكوكيز)
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    استخدام ملفات تعريف الارتباط
                  </Typography>
                  <Typography>
                    تستخدم منصة شحن ملفات تعريف الارتباط لتحسين تجربتك عند زيارة موقعنا الإلكتروني
                    أو استخدام تطبيقنا. ملفات تعريف الارتباط هي ملفات نصية صغيرة تُخزن على جهازك عند
                    زيارة موقعنا أو استخدام تطبيقنا، وتساعد في تحسين وظائف الموقع والتطبيق وتقديم
                    تجربة مخصصة.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    أنواع ملفات تعريف الارتباط التي نستخدمها
                  </Typography>
                  <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        ملفات تعريف الارتباط الأساسية: هذه الملفات ضرورية لتمكينك من التنقل في
                        الموقع واستخدام ميزاته، مثل الوصول إلى المناطق الآمنة من الموقع. بدون هذه
                        الملفات، لا يمكن تقديم الخدمات التي تطلبها.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        ملفات تعريف الارتباط للأداء: تجمع هذه الملفات معلومات حول كيفية استخدام
                        الزوار للموقع، مثل الصفحات التي يزورونها كثيرًا، وتساعدنا في تحسين أداء
                        الموقع. لا تجمع هذه الملفات معلومات تحدد هوية الزائر.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        ملفات تعريف الارتباط الوظيفية: تسمح هذه الملفات للموقع بتذكر الاختيارات التي
                        تقوم بها (مثل اسم المستخدم، اللغة، أو المنطقة التي تتواجد فيها) وتوفر ميزات
                        محسنة ومخصصة. يمكن لهذه الملفات تذكر التغييرات التي أجريتها على حجم النص
                        والخطوط وأجزاء أخرى من صفحات الويب التي يمكنك تخصيصها.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        ملفات تعريف الارتباط للتسويق والإعلان: تُستخدم هذه الملفات لتقديم الإعلانات
                        ذات الصلة بك وباهتماماتك. كما تُستخدم للحد من عدد مرات مشاهدة الإعلان
                        وللمساعدة في قياس فعالية الحملات الإعلانية. عادة ما توضع هذه الملفات بواسطة
                        شبكات الإعلانات بإذن من مشغل الموقع. تتذكر هذه الملفات أنك قد زرت الموقع
                        ويتم مشاركة هذه المعلومات مع مؤسسات أخرى مثل المعلنين.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    كيفية إدارة ملفات تعريف الارتباط
                  </Typography>
                  <Typography>
                    يمكنك التحكم في ملفات تعريف الارتباط أو حذفها من خلال إعدادات المتصفح الخاص بك.
                    يمكنك حذف جميع ملفات تعريف الارتباط المخزنة على جهازك ومعظم المتصفحات تتيح لك
                    حظر تخزينها. ومع ذلك، إذا قمت بحذف ملفات تعريف الارتباط أو حظرتها، فقد تحتاج إلى
                    إعادة ضبط تفضيلاتك في كل مرة تزور فيها الموقع، وقد لا تعمل بعض الخدمات والوظائف
                    بشكل صحيح.
                  </Typography>
                  <Typography>
                    الموافقة على استخدام ملفات تعريف الارتباط باستخدامك لموقع منصة شحن أو تطبيقها،
                    فإنك توافق على استخدامنا لملفات تعريف الارتباط وفقًا لهذه السياسة. إذا لم توافق
                    على استخدام ملفات تعريف الارتباط، يجب عليك ضبط إعدادات متصفحك وفقًا لذلك أو
                    التوقف عن استخدام الموقع والتطبيق.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>التحديثات</Typography>
                  <Typography>
                    {' '}
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      تحديث سياسة الخصوصية:
                    </Typography>{' '}
                    قد نقوم بتحديث سياسة ملفات تعريف الارتباط من وقت لآخر لتعكس التغييرات في
                    ممارساتنا أو لأسباب تشغيلية أو قانونية أو تنظيمية أخرى. سنقوم بنشر أي تغييرات
                    على هذه السياسة على موقعنا أو تطبيقنا.
                  </Typography>
                  <Typography>
                    إذا كان لديك أي استفسارات أو تعليقات بخصوص سياسة ملفات تعريف الارتباط، يمكنك
                    التواصل معنا عبر البريد الإلكتروني أو وسائل الاتصال الأخرى المتاحة على الموقع.
                  </Typography>
                  <Typography>
                    نحتفظ بالحق في تحديث سياسة الخصوصية من وقت لآخر لتعكس التغييرات في ممارساتنا أو
                    القوانين المعمول بها. سيتم إشعارك بأي تغييرات هامة من خلال الموقع الإلكتروني أو
                    بوسائل أخرى مناسبة.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>
                    بموجب استخدامك لمنصة شحن، فإنك توافق على الشروط والأحكام المذكورة أعلاه، وتقر
                    بأنك تفهم وتوافق على جمع واستخدام بياناتك الشخصية كما هو موضح.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>الإخطار</Typography>
                  <Typography>
                    {' '}
                    يجوز لـ”منصة شحن” أن ترسل إخطارًا عن طريق إرسال إخطار عام عن الخدمة أو التطبيق،
                    أو بإرسال بريد إلكتروني إلى عنوانك البريدي المُسجل في معلومات الحساب لدى “منصة
                    شحن”، أو بإرسال مكاتبة بالبريد العادي على عنوانك المسجل في معلومات الحساب لدى
                    “منصة شحن”.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>التواصل معنا</Typography>
                  <Typography>
                    {' '}
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      استفسارات وسياسات:
                    </Typography>{' '}
                    إذا كان لديك أي استفسارات أو تعليقات بخصوص سياسة الخصوصية، يمكنك التواصل معنا
                    عبر البريد الإلكتروني أو وسائل الاتصال الأخرى المتاحة على الموقع.
                  </Typography>
                  <Typography>
                    {' '}
                    باستخدامك لمنصة "شحن"، فإنك توافق على سياسة الخصوصية هذه وتقر بأنك تفهم وتوافق
                    على جمع واستخدام بياناتك الشخصية كما هو موضح.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>الملكية الفكرية</Typography>
                  <Typography>
                    جميع الحقوق المتعلقة بالموقع الإلكتروني لمنصة شحن وتطبيقات الهواتف الذكية (يشار
                    إليهما معًا بـ"منصة شحن")، بما في ذلك حقوق النشر والتأليف، العلامات التجارية،
                    الشعارات، التصاميم، البرمجيات، المحتوى النصي والرسومي، والبرامج الحاسوبية،
                    والأيقونات، والصور، والمقاطع الصوتية، والفيديو، والبيانات، والمعلومات، وجميع
                    المواد الأخرى المتاحة عبر المنصة، (يشار إليها مجتمعة بـ"المحتوى") هي ملكية حصرية
                    لمنصة شحن أو الجهات المرخصة لها، ومحمية بموجب قوانين الملكية الفكرية المحلية
                    والدولية.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>استخدام المحتوى</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يمنع منعا باتا نسخ أو تعديل أو توزيع أو نشر أو تحميل أو عرض أو نقل أو بيع أو
                      إعادة إنتاج أي جزء من المحتوى دون الحصول على إذن خطي مسبق من منصة شحن.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يحق للمستخدمين استخدام المحتوى فقط لأغراضهم الشخصية وغير التجارية، وبما يتفق
                      مع شروط وأحكام الاستخدام هذه.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>العلامات التجارية</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      جميع العلامات التجارية والشعارات المعروضة على منصة شحن هي ملك لمنصة شحن أو
                      الجهات المرخصة لها. يمنع استخدام أي علامة تجارية بأي شكل من الأشكال دون الحصول
                      على إذن خطي مسبق من صاحب العلامة التجارية.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يشمل ذلك العلامات التجارية مثل "شحن"، والشعارات المرتبطة بها، وأي أسماء أخرى
                      أو رموز تعرف على خدمات منصة شحن.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>حقوق البرمجيات </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      تمتلك منصة شحن جميع حقوق البرمجيات المستخدمة في تشغيل الموقع الإلكتروني
                      والتطبيقات. لا يحق لأي شخص نسخ أو تعديل أو توزيع أو إعادة بيع أي جزء من
                      البرمجيات.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}> الاستخدام المحظور</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يمنع استخدام أي وسيلة آلية مثل الروبوتات أو العناكب أو أي أدوات آلية أخرى
                      للوصول إلى أي جزء من منصة شحن أو نسخ المحتوى منها.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يمنع محاولة تفكيك أو عكس هندسة أي جزء من البرمجيات المستخدمة على منصة شحن.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    المحتوى المقدم من المستخدمين
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      أي محتوى يقوم المستخدمون بإرساله أو رفعه إلى منصة شحن (بما في ذلك التعليقات،
                      التقييمات، الصور، وغيرها) يصبح ملكًا لمنصة شحن، ويحق لمنصة شحن استخدامه بأي
                      شكل تراه مناسبًا، بما في ذلك لأغراض التسويق والترويج، دون الحاجة إلى الحصول
                      على موافقة مسبقة من المستخدم أو تقديم تعويض له.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يضمن المستخدم أن المحتوى المقدم لا ينتهك حقوق الملكية الفكرية لأي طرف ثالث،
                      ويتحمل كامل المسؤولية عن أي خرق لهذا الضمان.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    الإخلال بالملكية الفكرية
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      تحتفظ منصة شحن بالحق في اتخاذ جميع الإجراءات القانونية المناسبة ضد أي استخدام
                      غير مصرح به لمحتواها أو برمجياتها أو علاماتها التجارية.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      في حال اكتشاف أي انتهاك لحقوق الملكية الفكرية، يلتزم المستخدمون بإبلاغ منصة
                      شحن فورًا لاتخاذ الإجراءات اللازمة.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>التعويض</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يلتزم المستخدم بتعويض منصة شحن عن جميع الأضرار والخسائر والتكاليف التي قد تنشأ
                      عن أي انتهاك من جانبه لحقوق الملكية الفكرية الخاصة بمنصة شحن أو الأطراف
                      المرخصة لها.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      هذا البند يهدف إلى حماية حقوق منصة شحن الفكرية وضمان استخدامها بشكل قانوني
                      وأخلاقي من قبل جميع المستخدمين. استخدامك لمنصة شحن يعني موافقتك على الالتزام
                      بهذه الشروط والأحكام الخاصة بالملكية الفكرية.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>سياسة التأمين</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>تعريف: </Typography>
                  <Typography>
                    في منصة شحن، نحرص دائماً على سلامة وتأمين بضائع عملائنا بأعلى معايير الجودة
                    والأمان. التأمين على البضائع هو إجراء حيوي يهدف إلى حماية ممتلكاتك الثمينة من
                    المخاطر المحتملة أثناء عمليات النقل. يعتبر التأمين بمثابة شبكة أمان مالية تحمي
                    البضائع من الأضرار الناجمة عن الحوادث أو الظروف الخارجة عن إرادتنا. نحن نعمل مع
                    شركات تأمين ذات سمعة ممتازة وموثوقية عالية لضمان توفير أفضل تغطية تأمينية لبضائع
                    عملائنا.
                  </Typography>
                  <Typography>
                    اختيار التأمين هو خطوة ضرورية وملزمة لكل عميل، حيث يجب على العميل إدخال جميع
                    المعلومات والبيانات الدقيقة المتعلقة بالبضائع المنقولة. عدم التزام العميل
                    بتزويدنا بالمعلومات الصحيحة والكاملة يعد إهمالاً منه ويتحمل مسؤوليته الكاملة. في
                    حال وقوع أي ضرر للبضائع نتيجة لعدم تقديم المعلومات اللازمة، تخلي منصة شحن
                    مسؤوليتها عن تغطية تلك الأضرار، ويكون العميل مسؤولاً بالكامل عن أي خسائر محتملة.
                  </Typography>
                  <Typography>
                    كما أن إدخال بيانات غير صحيحة مثل قيمة البضائع أو نوعها، على سبيل المثال لا
                    الحصر، يلغي وثيقة التأمين، ولا يحق للعميل المطالبة بأي تعويض. نؤمن بأن تأمين
                    البضائع يعزز الثقة بيننا وبين عملائنا، ويعكس التزامنا بتقديم خدمات نقل موثوقة
                    وفعالة. يتيح التأمين لعملائنا متابعة أعمالهم بثقة وراحة بال، مع العلم أن
                    ممتلكاتهم محمية بأفضل طريقة ممكنة.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>التعريفات</Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      المؤمن له:
                    </Typography>{' '}
                    الشخص أو الكيان الذي تم تأمين البضائع أو الممتلكات لصالحه بموجب بوليصة التأمين.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      التأمين :
                    </Typography>
                    هو العقد الذي يلتزم بموجبه المؤمن بتعويض المؤمن له عن الأضرار أو الخسائر التي قد
                    تتعرض لها البضائع المؤمن عليها خلال فترة محددة.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      العميل:
                    </Typography>{' '}
                    الشخص أو الكيان الذي يقوم بطلب خدمات النقل أو التخزين من منصة شحن.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      منصة شحن:
                    </Typography>
                    العلامة التجارية المملوكة لشركة فكر للاتصالات وتقنية المعلومات، والتي تقدم خدمات
                    النقل والتخزين للبضائع عبر منصة إلكترونية متكاملة.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      التغليف والتعبئة حسب المواصفات والمقاييس:
                    </Typography>
                    الإجراءات والمعايير المتبعة في تغليف وتعبئة البضائع لضمان سلامتها أثناء النقل
                    والتخزين. يجب أن تكون هذه الإجراءات متوافقة مع المواصفات القياسية والمعايير
                    المعترف بها دولياً.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      التحميل والرص حسب الموصفات والمقاييس الدولية:
                    </Typography>
                    يعني عملية تحميل وترتيب البضائع على وسائل النقل بطريقة تتوافق مع المعايير
                    الدولية لضمان السلامة والكفاءة في النقل.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      المؤمن عليه:
                    </Typography>{' '}
                    البضائع أو الممتلكات التي تم تأمينها بموجب بوليصة التأمين.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      قيمة المؤمن عليه:
                    </Typography>{' '}
                    القيمة المالية للبضائع أو الممتلكات المؤمن عليها، كما هو محدد في بوليصة التأمين،
                    وتعتبر الأساس لحساب التعويضات في حالة حدوث خسارة أو ضرر.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    بند التعبئة والتغليف والتحميل حسب المواصفات والمقاييس الدولية
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      التغليف والتعبئة حسب المواصفات والمقاييس الدولية:
                    </Typography>
                    يجب على العملاء التأكد من أن جميع البضائع المنقولة عبر منصة شحن تكون معبأة
                    ومغلفة وفقًا لأعلى المعايير والمواصفات الدولية لضمان سلامتها وحمايتها أثناء
                    النقل والتخزين. فيما يلي{' '}
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    بعض النقاط الأساسية التي يجب مراعاتها:
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    1.المواد المستخدمة في التغليف:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب استخدام مواد تغليف ذات جودة عالية ومناسبة لنوع البضائع المنقولة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب أن تكون مواد التغليف قوية ومتينة لحماية البضائع من الصدمات والتلف.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يفضل استخدام صناديق كرتونية مزدوجة الجدران أو صناديق خشبية عند الضرورة.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>2.التعبئة الداخلية:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب تعبئة البضائع بشكل محكم داخل الصناديق لتجنب التحرك أثناء النقل.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      استخدام مواد تعبئة داخلية مثل الفوم، الببل راب (فقاعات الهواء)، والورق المقوى
                      لضمان ثبات البضائع ومنع تحركها.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>3.ختم الصناديق:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب ختم الصناديق بشكل جيد باستخدام شريط لاصق قوي لضمان عدم فتحها أثناء النقل.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يفضل استخدام شريط لاصق عريض وذو جودة عالية.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    4.علامات التحذير والملصقات:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب وضع علامات التحذير المناسبة على الصناديق مثل "قابل للكسر"، "حافظ على
                      الجاف"، و"هذا الجانب لأعلى".
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      استخدام ملصقات تحتوي على تفاصيل الحمولة والعنوان بشكل واضح.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>5.التغليف الخاص:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعض البضائع قد تتطلب تغليف خاص مثل المنتجات المبردة أو المجمدة، التي تحتاج إلى
                      تغليف عازل للحفاظ على درجة الحرارة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب تغليف المواد السائلة بشكل محكم لمنع التسرب.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>6.المعايير الدولية:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب أن تتوافق عملية التعبئة والتغليف مع المعايير والمواصفات الدولية مثل ISO،
                      ASTM، ISTA لضمان الجودة والأمان.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب مراجعة المعايير الخاصة بنوع البضائع للتأكد من اتباع الإجراءات الصحيحة.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>7.إرشادات المصنع:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب اتباع إرشادات المصنع للمنتج فيما يخص كيفية التعبئة والتغليف للمنتج لضمان
                      سلامته.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      التحقق من التعليمات الخاصة بكل منتج لتطبيق أفضل ممارسات التعبئة والتغليف.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>8.التوثيق والمستندات:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب الاحتفاظ بجميع المستندات والفواتير التي تثبت تفاصيل البضائع والتغليف.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب تقديم هذه المستندات عند الطلب للتأكد من مطابقة البضائع للمواصفات
                      والمقاييس.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    التحميل والرص حسب المواصفات والمقاييس الدولية:
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      التحميل والرص:
                    </Typography>{' '}
                    يجب أن تتم عملية تحميل ورص البضائع في الشاحنات وفقًا لأعلى المعايير الدولية
                    لضمان سلامتها وأمانها أثناء النقل.{' '}
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>
                    فيما يلي الإرشادات الأساسية للتحميل والرص والواجب على المؤمن له أو جهة التحميل
                    التحقق منها وتطبيقها:
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>1.التخطيط المسبق:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب تخطيط عملية التحميل مسبقًا لضمان الاستخدام الأمثل لمساحة الشاحنة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      تحديد الوزن الأقصى المسموح به للشاحنة وتوزيع الوزن بالتساوي لتجنب الحمولة
                      الزائدة.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    2.استخدام المعدات المناسبة:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب استخدام المعدات المناسبة مثل الرافعات الشوكية والأحزمة والحبال لضمان تحميل
                      البضائع بأمان.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      التأكد من أن المعدات المستخدمة تتوافق مع نوع وحجم البضائع المنقولة.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>3.التثبيت والتأمين:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب تثبيت البضائع داخل الشاحنة بشكل محكم باستخدام الأحزمة والحبال لتجنب تحركها
                      أثناء النقل.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      استخدام وسائل التثبيت الإضافية مثل الفواصل والمصدات لضمان ثبات البضائع.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>4.التوزيع المتساوي:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      توزيع الوزن بشكل متساوٍ داخل الشاحنة لتجنب انزلاق البضائع أو انقلاب الشاحنة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      ترتيب البضائع بشكل يضمن سهولة الوصول إليها عند التفريغ.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>5.التأكد من التهوية:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      في حالة نقل البضائع التي تحتاج إلى تهوية، يجب التأكد من وجود فتحات تهوية كافية
                      في الشاحنة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      الحفاظ على درجة حرارة مناسبة للبضائع الحساسة للحرارة.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>6.التحقق من التثبيت:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب التحقق من تثبيت البضائع بشكل جيد من قبل المؤمن له أو الجهه المسؤولة عن
                      التحميل قبل بدء الرحلة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب على المؤمن له أو جهة التحميل التأكد من عدم وجود أي عناصر غير مثبتة قد تسبب
                      خطرًا أثناء النقل.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    7.اتباع المعايير الدولية:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب أن تتوافق عملية التحميل والرص مع المعايير والمواصفات الدولية مثل ISO وASTM
                      لضمان الجودة والأمان.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      مراجعة التعليمات الخاصة بكل نوع من البضائع لتطبيق أفضل ممارسات التحميل والرص.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>8.إرشادات المصنع:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب اتباع إرشادات المصنع للمنتج فيما يخص كيفية التحميل والرص لضمان سلامته.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      التحقق من التعليمات الخاصة بكل منتج لتطبيق أفضل ممارسات التحميل والرص.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>
                    باتباع هذه الإرشادات، تضمن منصة شحن سلامة البضائع وحمايتها من التلف أثناء عمليات
                    النقل والتخزين، مما يعزز من ثقة العملاء في خدماتها ويضمن تحقيق أعلى مستويات
                    الرضا.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>بند التغطية</Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      التغطية:
                    </Typography>{' '}
                    تغطي وثيقة التأمين التي توفرها منصة شحن جميع المخاطر المتعلقة بفقدان أو تلف
                    البضائع أثناء النقل، بما في ذلك الأضرار الناتجة عن الحوادث، الحريق، الانفجارات،
                    والسرقة، بشرط أن تكون هذه المخاطر غير مذكورة في بند الاستثناءات.
                  </Typography>
                  <Typography>
                    تشمل التغطية أيضًا الأضرار التي قد تحدث نتيجة لعوامل طبيعية مثل الأمطار أو
                    الفيضانات، بشرط أن تكون البضائع مغلفة بشكل مناسب ومحمية حسب المعايير الدولية
                    المعتمدة.
                  </Typography>
                  <Typography>
                    بالإضافة إلى ذلك، تشمل التغطية الأضرار الناتجة عن سوء التعامل أو الإهمال من قبل
                    الناقلين أو سائقيهم، طالما أن هذا الإهمال لم يذكر ضمن الاستثناءات.
                  </Typography>
                  <Typography>
                    وتغطي وثيقة التأمين جميع البضائع التي يتم الإفصاح عنها بشكل صحيح في بوليصة
                    الشحن، ويتم تحديد قيمة التعويض بناءً على قيمة البضائع المؤمن عليها كما هو مذكور
                    في وثيقة التأمين.
                  </Typography>
                  <Typography>
                    يجب على العميل مراجعة بند الاستثناءات لفهم جميع الحالات التي لا يغطيها التأمين.
                    في حال وجود أي تضارب بين التغطية والاستثناءات، تكون الاستثناءات هي السائدة.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      تشمل التغطية:
                    </Typography>
                    جميع أنواع البضائع والمنتجات ما لم تذكر في بند الاستثناءات والأضرار الناتجة عن
                    الحوادث (مثل الحوادث المرورية). والأضرار الناتجة عن الكوارث الطبيعية (مثل
                    الفيضانات، الزلازل). والأضرار الناتجة عن الحرائق والانفجارات. والسرقة بشرط عدم
                    تعارضها مع بند الاستثناءات. والأضرار الناتجة عن سوء التعامل أو الإهمال من قبل
                    الناقلين أو سائقيهم. وجميع البضائع المغلفة والمعبأة بشكل صحيح وفقًا للمعايير
                    والمواصفات المعتمدة.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>
                    نلفت انتباه العميل إلى ضرورة الاطلاع على بند الاستثناءات لمعرفة الحالات التي لا
                    يغطيها التأمين والتي قد تؤثر على تقديم المطالبات.
                  </Typography>
                  {/* <!--------------- Insurance Exclusions Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>استثناءات التأمين</Typography>
                  <List sx={{ listStyleType: 'decimal', pl: 4, ml: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>تبع السجائر والسيجار والخمور والمسكرات.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>طلاء الساعات والساعات من الذهب والمجوهرات.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>الفضة والمعادن النفيسة والأحجار الكريمة.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        النقود الورقية، سندات الكوبونات، سندات الكمبيالات، والسندات.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>الوثائق والمخطوطات:</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>بند إنهاء تخزين البضائع في النقل.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        تدمير أو الأضرار التي لحقت بزجاج صيني أو صور خزفية أو أجهزة علمية أو تماثيل
                        الرخام أو الجبس.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        سرقة البضاعة أثناء تواجد الشاحنة في أحد مواقع المؤمن له أو أحد عملائه.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        أي خسارة أو الغاز السائل أو البضائع من الحاويات التي تسرب أو تنثر.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        الدمار أو التلف في الممتلكات المؤقتة لأكثر من سبعة أيام أثناء نقلها لأغراض
                        التخزين واستكمال التعبئة أو التجهيز.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        السرقة أو الاختلاس الذي ينجم عن أي موظف من موظفي المؤمّن له الرئيسي أو
                        الثانوي.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        الخسارة أو الأضرار التي لحقت بموضوع المؤمّن عليه الناجم عن أي اختلاف في
                        درجات الحرارة, لا يغطي التأمين الأضرار الناتجة عن اختلاف درجات الحرارة إلا
                        إذا كانت بسبب تعطل أجهزة التبريد لمدة لا تقل عن 12 ساعة متتالية.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        التلوث الإشعاعي شرط استبعاد, لا تكون منصة شحن مسؤولة في حال فقدان أو تدمير
                        أو إتلاف الممتلكات الناتجة عن الإشعاعات المؤينة أو التلوث الإشعاعي من أي
                        وقود نووي أو من النفايات النووية الناتجة عن احتراق الوقود النووي.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        ضرر أو خسارة حساب تعزى إلى سوء سلوك متعمد من جانب المؤمن له.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        تسرب مألوف وفقدان في الوزن العادي أو الحجب أو التآكل من استعمال لموضع
                        المؤمّن عليه.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        التلف أو التكاليف بسبب عدم كفاية أو عدم ملائمة التعبئة أو في الأعداد بموضوع
                        المؤمّن عليه.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        خسارة أو الضرر الناجم عن عيب ملازم أو طبيعة الموضوع المؤمّن عليه.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        ضرر أو خسارة قد تسبب بشكل مباشر عن طريق حساب تأخير حتى ولو تسبب في تأخير من
                        قبل المؤمّن عليه ضد مخاطر.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        ضرر أو خسارة ناشئة عن القضايا الخاصة بأسلحة الحرب التي تستخدم لانشطار عن
                        نووي أو رد فعل مثل غيرها من الأنشطة الإشعاعية.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        الضرر أو الخسارة الناشئة عن منع أو حجم العمل أيًا كانت تسميتها الناجمة عن أي
                        إضرابات أو إزعاجات عمالية والشغب والعصيان.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        الضرر أو الخسارة الناجمة عن الحروب والحروب الأهلية والثورات والتمرد
                        والعصيان:
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        ضرر أو خسارة ناجمة عن الاستيلاء والحجز والتوقيف والاعتقال.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        عدم استلام البضائع المنقولة من قبل العميل خلال الوقت المحدد.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>عدم وجود تقرير من الشرطة أو نجم في حالة الحوادث.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>عدم التحميل والتنزيل وفقًا للمعايير الدولية المطلوبة.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        أي خسارة أو ضرر تسببها الجراثيم والفطريات والميكروبات والفيروسات وما شابهها
                        من المخاطر.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        عدم وقوف الشاحنة في مكان مؤمن عليه في أحد مقرات العميل.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        أضرار مياه الأمطار ما لم تكن محمولة في مركبة مغلقة والضرر الناتج عن إهمال في
                        اختيار نوع الشاحنة المناسب للحمولة، مثل اختيار شاحنة مكشوفة ونتج عن ذلك تلف
                        البضاعة نتيجة الظروف الجوية كالأمطار، أو نقل بضائع ثمينة على شاحنات مكشوفة
                        مما يجعلها عرضة للسرقة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>بند استبعاد العقوبات.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>تحميل البضائع بارتفاع أعلى من جسور الشاحنة.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>تحميل الشاحنة بأكثر من الوزن النظامي المسموح به.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        الانحرافات الميكانيكية والكهربائية والإلكترونية والعيوب الكامنة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        تغطية التأمين هذه تعتمد على أساس المبلغ المؤمن بالكامل وفي حالة إعلان أي
                        قيمة أقل من القيمة الفعلية للبضائع، سيتم اعتبارها انتهاكًا لمبدأ حسن النية
                        القصوى وسيتم رفض المطالبة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        التأخر في إخطار منصة شحن مما ترتب عليه اختفاء الأدلة أو صعوبة التحقق من
                        الواقعة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        المنتجات غير المغلفة ومرصوصة بشكل جيد وبحسب المواصفات والمقاييس.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>التحميل خارج محيط الشاحنة.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        المنتجات سهلة الكسر مثل المرايا التي توضع حرة وليست على طبالي ومرصوصة ومغلفة
                        ومعبأة، أو الرخام غير المغلف والمرصوص ومعبأ على طبالي،{' '}
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        الشاشات والراديو والمسجلات والأجهزة المستعملة أو الجديدة والغير معبأة ومغلفة
                        ومرصوصة حسب المواصفات والمقاييس.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        البضائع التي تتجاوز قيمتها 500 ألف ريال سعودي ما لم يتم أخذ الموافقة عليها
                        مسبقاً.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        خسائر أو تدمير أو تلف الثروة الحيوانية ذات طبيعة خطيرة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>المواشي بجميع أنواعها.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>الكيابل الكهربائية والنحاس.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        تحميل شاحنة غير مطابقة لبيانات الشاحنة الموضحة في المنصة أو بوليصة الشحن.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>سقوط أو ضرر للبضاعة أثناء عملية التحميل أو التنزيل.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        سقوط البضاعة أو جزء منها نتيجة سوء الطرق أو وعورتها لموقع التنزيل أو التحميل
                        بشرط عدم وجود طرق بديلة سليمة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        الخدوش الصغيرة أو الانبعاجات أو تغير اللون للشحنة. إذا كان الضرر خارجيًا أو
                        ظاهريًا ولا يمنع الاستفادة من المنتج مثل خدش أو قطع في التغليف دون تلف
                        للمنتج الداخلي. على سبيل المثال، علبة زيت تغير شكلها نتيجة سقوط أو ضغط ولكن
                        الزيت لم يتسرب منها.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        تلف جزء من الكل، حيث يتم تعويض الجزء التالف فقط دون السليم.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        عدم وجود فواتير أو مستندات سليمة تثبت قيمة المؤمن علية.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        النواقص والفقد في جزء من البضاعة دون صور توضح شكل البضاعة بعد تحميلها وصورة
                        للبضاعة قبل تنزيلها توضح النقص واختلاف ترتيب البضاعة. يجب على المؤمن تزويد
                        منصة شحن بفيديو للشاحنة بعد تحميلها من كاميرات المراقبة في موقع التحميل
                        وفيديو آخر عند وصول الناقل لموقع التنزيل.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        الرحلات غير المسجلة في منصة شحن أو تلك التي لم يرفع العميل بها طلبًا رسميًا،
                        مثل التعاون مع سائق تابع لمنصة شحن دون رفع طلب أو الاتفاق مع أحد ممثلي منصة
                        شحن بأمر مخالف لسياسات المنصة و دون إذن خطي ورسمي.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>بند استبعاد التسرب والتلوث والتلوث.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        الحرب، التخريب، الإرهاب، المخاطر السياسية ومخاطر SRCC.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>بند استبعاد الهجوم السيبراني. CL. 380- I 0.1 1.03.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        بند استبعاد المخاطر السياسية، الضمان المالي ومخاطر الائتمان.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography>
                    تلتزم منصة شحن بحماية حقوق عملائها وضمان تجربة نقل آمنة وفعالة، وفي حال حدوث أي
                    من الحالات المذكورة أعلاه، فإن التأمين لن يغطي الأضرار الناجمة عنها، ويتحمل
                    العميل المسؤولية الكاملة عن أي تكاليف إضافية أو خسائر.
                  </Typography>
                  {/* <!--------------- Clause on Liability in Cases of Intentional Negligence by the Carrier Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    بند المسؤولية في حالات الإهمال المتعمد من الناقل
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>تعريف:</Typography>
                    <Typography>
                      {' '}
                      في بعض الحالات، مثل الإهمال المتعمد والغير متعمد من الناقل الذي نتج عنه تلف
                      للبضاعة أو فقدها أو نقص في البضاعة، قد لا يغطي التأمين هذه الأضرار. في هذه
                      الحالات، يتم ملاحقة الناقل قانونيًا بعد ثبوت الأدلة والتحقق من صحة المطالبة.
                      لتقديم مطالبة صحيحة، يجب على العميل توفير الأدلة التي توضح تغير في ترتيب
                      البضاعة أو شكلها بعد التحميل من كاميرات أو صور في موقع التحميل، وصور أو فيديو
                      للبضاعة في موقع التسليم يظهر بها تغير ترتيب وشكل البضاعة عند التسليم وقبل
                      التنزيل وأي مستندات أخرى إضافية. كما ننوه بأن الناقل غير معني بجرد البضاعة
                      المحملة وحصرها أو حصر ما بداخلها من كميات لاستحالة ذلك. شركة التأمين تعد
                      الناقل مؤمنًا على البضاعة، فأي إهمال أو تعمد من الناقل بإلحاق الضرر يسقط
                      التأمين ويستدعي رفع دعوى قضائية وقانونية لمطالبة الناقل بالتعويض مباشرة.
                    </Typography>
                    <br />
                    <Typography>أمثلة على ذلك:</Typography>
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        إذا أقدم ناقل أو تابع له بسرقة البضاعة أو جزء منها أو تآمر مع أطراف أخرى
                        لسرقتها في منطقة غير مؤمنة لا في موقع العميل أو في موقع بدون كاميرات مراقبة،
                        يرفض التأمين التعويض. في هذه الحالة، تقوم منصة شحن برفع دعوى على الناقل تثبت
                        فعل سائقها.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        إذا تم نقل منتجات تحتاج إلى تبريد أو تجميد وقام السائق بالعبث بجهاز التبريد
                        أو حدث عطل في جهاز التبريد أثناء النقل مما نتج عنه تلف البضاعة، يرفض التأمين
                        التعويض لأن الضرر كان من جهة الناقل. هنا، تقوم منصة شحن بملاحقة الناقل
                        قانونيًا وقضائيًا لاسترداد حق العميل والمؤمن له.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography>
                    {' '}
                    على العميل المؤمن له التعاون مع منصة شحن في جميع الحالات لإثبات حقه بالقانون. لن
                    تتوانى منصة شحن أو تدخر جهدًا في ملاحقة المتسبب قانونيًا وقضائيًا لإسترداد
                    واستعادة حق عميلها,
                  </Typography>
                  <Typography>
                    يجب أن يكون واضحًا أن العميل ليس له الحق بمقاضاة منصة شحن أو موظفيها أو شركة فكر
                    للاتصالات وتقنية المعلومات في أي أمر مثل التعويض المباشر أو تحمل المسؤولية. دور
                    منصة شحن هو توجيه مركبات نقل البضائع، والناقل هو المسؤول. باستخدام خدمات منصة
                    شحن، يوافق العميل على تحييد منصة شحن وموظفيها ومالكيها عن أي مساءلة قانونية قد
                    تنشأ. يجب على العميل التعاون مع منصة شحن ودفع الضرر عنها في جميع الأحوال وإخلاء
                    مسؤوليتها عن أي ضرر.
                  </Typography>
                  {/* <!--------------- Prohibitions Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>المحظورات</Typography>
                  <Typography>
                    يحظر على مستخدمي تطبيقات منصة شحن والموقع الإلكتروني القيام بما يلي:
                  </Typography>
                  <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        {' '}
                        نقل أو إرسال البضائع والمواد المحظورة والممنوعة:
                      </Typography>
                    </ListItem>
                    <List sx={{ listStyleType: 'disc', pl: 4 }}>
                      <ListItem sx={{ display: 'list-item' }}>
                        {' '}
                        يشمل ذلك المواد الكيميائية والخطرة، نقل الأموال، وأي مواد مخالفة للأنظمة
                        المعمول بها في المملكة العربية السعودية.
                      </ListItem>
                      <ListItem sx={{ display: 'list-item' }}>
                        {' '}
                        يتحمل المستخدم وحده المسؤولية الكاملة عن أي مخالفة لهذه الأنظمة.
                      </ListItem>
                    </List>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        {' '}
                        استخدام التطبيقات والموقع الإلكتروني في غير أغراضها المخصصة:
                      </Typography>
                    </ListItem>
                    <List sx={{ listStyleType: 'disc', pl: 4 }}>
                      <ListItem sx={{ display: 'list-item' }}>
                        {' '}
                        يحظر استخدام تطبيقات منصة شحن والموقع الإلكتروني في نقل الأفراد داخل أو خارج
                        المدن.
                      </ListItem>
                      <ListItem sx={{ display: 'list-item' }}>
                        {' '}
                        يحظر استخدام التطبيقات والموقع لأي أغراض غير مخصصة لها.
                      </ListItem>
                    </List>
                  </List>
                  <Typography>
                    باستخدامك لتطبيقات منصة شحن والموقع الإلكتروني، فإنك توافق على الامتثال لجميع
                    الأنظمة واللوائح المعمول بها وتتحمل المسؤولية الكاملة عن أي انتهاك قد يحدث.
                  </Typography>
                  {/* <!--------------- Insurance Claims Submission Mechanism Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    آلية تقديم المطالبات التأمينية
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    التقديم ومتابعة المطالبة:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>التحقق من التغطية:</Typography> التحقق
                      من الجدول الزمني وصياغة الوثيقة الخاصة بك لمعرفة ما إذا كانت تغطي الخسارة أو
                      الضرر وما إذا كانت أي أدلة محددة مطلوبة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>قراءة الشروط العامة:</Typography>{' '}
                      قراءة الشروط العامة واتباع أي تعليمات مذكورة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>التواصل مع منصة شحن:</Typography>{' '}
                      تواصل مع منصة شحن لتقديم المطالبة.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>المستندات المطلوبة:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      تقديم الوثائق: <br /> الوثائق التالية تشكل عادةً جزءًا أساسيًا من المطالبة
                      وينبغي تقديمها للشركة
                      <br />
                      <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          الفواتير التجارية لدعم القيم وتحديد شروط البيع.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>قوائم التعبئة إن وجدت.</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          إيصالات الاستلام، حسابات الشحن، إلخ. كدليل على حالته ووضع أي خسارة وقعت.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          الوثائق الأصلية للنقل، مثل بوليصة الشحن أو اتفاقية النقل.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          المراسلات مع الناقلين أو الموردين أو الأطراف الثالثة الأخرى لتحميلهم
                          المسؤولية عن أي خسارة.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          حساب أو تقدير المبالغ المطالب بها.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          أية وثائق أخرى ملائمة للشحنة أو النقل أو الخسارة.
                        </ListItem>
                      </List>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>متابعة المطالبة:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>تعيين خبير معاينة:</Typography> فور
                      الإبلاغ، ستقوم الشركة بتعيين خبير معاينة مستقل للنظر في القضية وذلك بهدف إنشاء
                      الظروف الدقيقة ومدى الخسارة. سيتم تنفيذ هذه العملية بأقل تأخير ممكن وعلى نفقة
                      الشركة.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>معالجة المطالبة: </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>ما سنفعله:</Typography> في معظم
                      الحالات، نحن قادرون على تسوية المطالبة بناء على المعلومات المقدمة في نموذج
                      المطالبة، مع الوثائق الأصلية المطلوبة. قد يكون من الضروري أحيانًا تعيين وكيل
                      لمساعدتنا في الاتفاق على تسوية سريعة وعادلة للمطالبة. سيتصل بك وكيلنا في أسرع
                      وقت ممكن لترتيب موعد لمناقشة المطالبة.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    الحلول والمسؤولية القانونية:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>الحلول:</Typography> قبل أو بعد دفع
                      تكاليف طلبك في إطار هذه الوثيقة، إذا طلب ذلك، يجب أن تسمح لنا باستغلال اسمك في
                      جميع الخطوات اللازمة لحين نفاد حقوقك ضد أي شخص آخر، ونحن سوف ندفع أي تكاليف
                      ونفقات يتم تكبدها.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>الاختصاص:</Typography> فيما يتعلق
                      بالمسؤولية القانونية تجاه أطراف ثالثة عن إصابات أو أضرار ناشئة في المملكة
                      العربية السعودية، سوف ندفع فقط فيما يتعلق بالقضايا التي حصلت في المملكة
                      العربية السعودية.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      تقوم الشركة بصفتها مديرًا لحساب حملة وثائق التأمين للمشتركين المؤمن لهم بإدارة
                      عمليات التأمين وما ينشأ عنها من حقوق ومسؤوليات، ولهذا الغرض تدير الشركة حسابين
                      منفصلين: حساب حملة الوثائق المشتركين المؤمن لهم لقيد الاشتراكات.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>شروط وأحكام التغطية:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      هذه هي الشروط جنبًا إلى جنب مع أي شروط خاصة، ومع ضرورة الامتثال لها. عدم
                      القيام بذلك قد يعني أننا لن نقبل أي مطالبة بموجب هذا التأمين.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب اتخاذ كل الخطوات المعقولة لمنع وقوع الحوادث وفقدان أو التلف أو المسؤولية
                      كما لو كنت من غير المؤمن عليهم.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      إذا كان أي خسارة مختلفة أو أي التزام قانوني بموجب هذه الوثيقة مغطى من قبل
                      تأمين آخر، فإننا لن ندفع أكثر من حصتنا في أي مطالبة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      لا يمكن نقل مصلحتك في هذه الوثيقة إلى أي شخص آخر ما لم تحصل على إذن خطي.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>مطالبات الإخطار:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      أنت أو أحد ممثليك يجب أن تتصل بنا في أقرب وقت ممكن وتقدم معلومات كاملة بمجرد
                      أن تدرك أن شيئًا قد حدث يستدعي إجراء مطالبة. يجب إخطارنا خطيًا أو عن طريق
                      الهاتف. إذا كان هناك سرقة أو محاولة سرقة أو تخريب أو أي فعل ضار، يجب عليك
                      أيضًا إبلاغ الشرطة على الفور.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>الأدلة:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب أن ترسل لنا أي إثبات نطلبه له علاقة بطلبك وتكاليفه ستكون مسؤوليتكم. بعض
                      البنود لديها متطلبات محددة، يرجى قراءة البند المتعلق بكيفية إجراء مطالبة لترى
                      ذلك.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>إجراء مطالبة:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب عدم تسوية أو رفض أي ادعاء أو التفاوض مع طرف ثالث دون الحصول على إذن خطي.
                      لدينا الحق باسمنا وباسمك في ما يلي:
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          تولي الدفاع القانوني أو تسوية أي مطالبة.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          البدء في إجراءات قانونية باسمك للحصول على تعويضات من أي شخص آخر.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          البدء في إجراءات قانونية باسمك لكي تسترد أية مدفوعات من أي شخص آخر والتي
                          تحققت بالفعل.
                        </ListItem>
                      </List>
                    </ListItem>
                  </List>
                  {/* <!--------------- Policy Cancellation Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>إلغاء وثيقتكم:</Typography>
                  <Typography>قد يتم إلغاء هذه الوثيقة من قبل الشركة في أي وقت في حال:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      المؤمن عليه لم يمتثل لأي ضمان أو تحسين للخطر بطريقة معينة وضمن الوقت المطلوب
                      الذي هو موضح في هذه الوثيقة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      إذا كان هناك أي تحريف احتيالي سواء توضيحي أو عدم الإفصاح عن أي واقعة مادية.
                      التعريف: واقعة مادية هي التي تؤثر في قدرة الشركة على اتخاذ القرار بخصوص قبول
                      الخطر أم لا، وفيما قررت الشركة قبول الشروط فيمكن للشركة أن تفعل ذلك.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      مصلحة المؤمن عليهم في هذه الوثيقة يمكن أن توقف أو قد يتم تغييرها جوهريًا أو
                      ماديًا.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      كان هناك تغيير جوهري في المهنة وعملية المعالجة والإجراءات أو غيرها من
                      التعديلات الجوهرية للمخاطر.
                    </ListItem>
                  </List>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>الحق في رفض طلب التعويض:</Typography>{' '}
                    يحق لمنصة شحن رفض طلب التعويض أو النظر فيه وعدم رفعه لشركة التأمين إذا كان يخالف
                    سياسة التأمين أو أحد بنودها.
                  </Typography>
                  {/* <!--------------- Duties of the Insured Customer Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    واجبات العميل المؤمن له:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>توفير بيانات دقيقة: </Typography> يجب
                      على العميل تقديم بيانات دقيقة وصحيحة عند إدخال معلومات الطلب، بما في ذلك
                      العناوين، وقيمة البضاعة، ونوع البضاعة، ودرجة الحرارة المطلوبة للبضائع القابلة
                      للتلف.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>تحديث المعلومات: </Typography> يجب على
                      العميل تحديث أي معلومات متعلقة بالطلب في حال حدوث أي تغيير لضمان دقة وسلامة
                      العملية.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>التعاون مع منصة شحن: </Typography> يجب
                      على العميل التعاون بشكل كامل مع منصة شحن في جميع مراحل النقل، بما في ذلك تقديم
                      المستندات والأدلة المطلوبة لإثبات أي مطالبة أو ضرر.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        اتباع التعليمات والإرشادات:
                      </Typography>{' '}
                      يجب على العميل اتباع التعليمات والإرشادات المقدمة من منصة شحن لضمان سير
                      العملية بسلاسة، بما في ذلك توجيهات التحميل والتفريغ، وإجراءات التبليغ عن
                      الأضرار أو النواقص.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>تقديم المستندات اللازمة: </Typography>{' '}
                      يجب على العميل تقديم جميع المستندات اللازمة لدعم أي مطالبة، مثل الفواتير
                      التجارية، قوائم التعبئة، إيصالات الاستلام، والوثائق الأخرى المطلوبة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>الالتزام بالوقت المحدد:</Typography>{' '}
                      يجب على العميل استلام البضائع المنقولة خلال الوقت المحدد، وعدم تأخير عملية
                      الاستلام لتجنب فرض أي رسوم إضافية أو إلحاق الضرر بالبضائع.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        الإبلاغ الفوري عن الأضرار:{' '}
                      </Typography>{' '}
                      يجب على العميل الإبلاغ الفوري عن أي أضرار أو نواقص تحدث للبضائع أثناء النقل،
                      وعدم إغلاق الطلب حتى يتم التحقق من الحالة وحصر الأضرار بحضور السائق أو ممثل
                      الناقل.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        اتباع الإجراءات القانونية:{' '}
                      </Typography>{' '}
                      في حال حدوث أي أضرار نتيجة إهمال أو تعمد من الناقل، يجب على العميل التعاون مع
                      منصة شحن في اتخاذ الإجراءات القانونية اللازمة ضد الناقل، وتقديم جميع الأدلة
                      والمستندات المطلوبة لدعم القضية.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>تحمل التكاليف الإضافية: </Typography>{' '}
                      يجب على العميل تحمل أي تكاليف إضافية قد تترتب على استخدام الطرق غير المعبدة أو
                      التحميل والتنزيل في المناطق الحيوية، وكذلك أي رسوم ناتجة عن التأخير أو المبيت.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>عدم نقل مسؤولية المخاطر:</Typography>{' '}
                      العميل مسؤول عن تعويض الناقل عن أي أضرار تحدث لشاحنات الناقل أو ممتلكاته نتيجة
                      استخدام الطرق غير المعبدة أو عدم الالتزام بالإجراءات الصحيحة للتحميل والتفريغ.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>تقديم درجة الحرارة بدقة: </Typography>{' '}
                      يجب على العميل تقديم درجة الحرارة المطلوبة للبضائع القابلة للتلف بدقة في خانة
                      الملاحظات الخاصة بالطلب لضمان سلامة البضائع. مثال درجة الحراه المطلوبه 0 مئوية
                      كحد أدنى ولا تتجاوز 4 درجات مئوية.
                    </ListItem>
                  </List>
                  <Typography>
                    بتنفيذ هذه الواجبات، يضمن العميل حماية حقوقه وضمان سير عملية النقل بسلاسة
                    وكفاءة، ويقلل من المخاطر المتعلقة بالنقل والتأمين.
                  </Typography>
                  {/* <!--------------- Additional Fees and Charges Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>رسوم وأجور إضافية</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    إقرار العميل والتزامه بدفع الرسوم
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يتعهد العميل بالالتزام بدفع جميع الرسوم المترتبة على الخدمات المقدمة من قبل
                      منصة شحن، بما في ذلك، على سبيل المثال لا الحصر، رسوم الإلغاء، ورسوم التأخير،
                      ورسوم المبيت، ورسوم استخدام الطرق غير المعبدة، ورسوم التحميل والتنزيل في
                      المناطق الحيوية. يقر العميل بأن هذه الرسوم قد تطبق على نفس الرحلة، وقد يتم
                      إصدار فاتورة بها إما ضمن فاتورة الطلب نفسه أو كفاتورة خارجية منفصلة.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>الشروط والأحكام:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يلتزم العميل بدفع هذه الرسوم فور صدورها، ولا يحق له التفاوض بشأنها أو تأخير
                      سدادها.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      لمنصة شحن الحق في اتخاذ الإجراءات المناسبة لحماية حقوقها وحقوق ناقليها، بما في
                      ذلك إيقاف تسليم الحمولة حتى يتم دفع الرسوم المستحقة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      لا تتحمل منصة شحن أي مسؤولية عن أي تعطيل أو تأخير قد يحدث للبضائع نتيجة تأخير
                      العميل في سداد الرسوم.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يتحمل العميل جميع الأضرار والرسوم الإضافية التي قد تترتب على تأخير سداد
                      الرسوم، بما في ذلك أي رسوم أخرى تترتب على هذا التأخير.
                    </ListItem>
                  </List>
                  {/* <!--------------- Liability Statement Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>بيان المسؤولية:</Typography>
                  <Typography>
                    بموجب استخدامه لخدمات منصة شحن، يقر العميل ويوافق على جميع البنود المذكورة
                    أعلاه، ويتحمل كامل المسؤولية عن دفع الرسوم وفقًا لسياسة منصة شحن والالتزام بجميع
                    الشروط والأحكام المنصوص عليها.
                  </Typography>
                  {/* <!--------------- Cancellation Fees Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>رسوم الإلغاء</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    التريلات بجميع أنواعها:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      قبل قبول الناقل للطلب يمكن للعميل الإلغاء دون رسوم.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد قبول الناقل للطلب رسوم الإلغاء 100 ريال.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد وصول الناقل لموقع التحميل 200 ريال.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد تحميل البضاعة أو جزء منها يخصم 450 ريال بالإضافة إلى 100 ريال عن كل ساعة
                      انتظار أو جزء من الساعة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      في حال كان الطلب يحتوي على عمال، سيتم خصم 50 ريال عن كل عامل في حال لم يتم
                      التحميل و100 ريال في حال البدء في عملية التحميل حتى وإن لم يتم الانتهاء منها.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>السقس بجميع أنواعه:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      قبل قبول الناقل للطلب يمكن للعميل الإلغاء دون رسوم.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد قبول الناقل للطلب رسوم الإلغاء 100 ريال.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد وصول الناقل لموقع التحميل 150 ريال.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد تحميل البضاعة أو جزء منها يخصم 400 ريال بالإضافة إلى 100 ريال عن كل ساعة
                      انتظار أو جزء من الساعة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      في حال كان الطلب يحتوي على عمال، سيتم خصم 50 ريال عن كل عامل في حال لم يتم
                      التحميل و100 ريال في حال البدء في عملية التحميل حتى وإن لم يتم الانتهاء منها.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>اللوري بجميع أنواعه:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      قبل قبول الناقل للطلب يمكن للعميل الإلغاء دون رسوم.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد قبول الناقل للطلب رسوم الإلغاء 75 ريال.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد وصول الناقل لموقع التحميل 125 ريال.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد تحميل البضاعة أو جزء منها يخصم 250 ريال بالإضافة إلى 50 ريال عن كل ساعة
                      انتظار أو جزء من الساعة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      في حال كان الطلب يحتوي على عمال، سيتم خصم 50 ريال عن كل عامل في حال لم يتم
                      التحميل و100 ريال في حال البدء في عملية التحميل حتى وإن لم يتم الانتهاء منها.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>الدينا بجميع أنواعها:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      قبل قبول الناقل للطلب يمكن للعميل الإلغاء دون رسوم.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد قبول الناقل للطلب رسوم الإلغاء 50 ريال.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد وصول الناقل لموقع التحميل 100 ريال.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد تحميل البضاعة أو جزء منها يخصم 150 ريال بالإضافة إلى 50 ريال عن كل ساعة
                      انتظار أو جزء من الساعة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      في حال كان الطلب يحتوي على عمال، سيتم خصم 50 ريال عن كل عامل في حال لم يتم
                      التحميل و100 ريال في حال البدء في عملية التحميل حتى وإن لم يتم الانتهاء منها.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>الونيت:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      قبل قبول الناقل للطلب يمكن للعميل الإلغاء دون رسوم.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد قبول الناقل للطلب رسوم الإلغاء 15 ريال.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد وصول الناقل لموقع التحميل 45 ريال.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      بعد تحميل البضاعة أو جزء منها يخصم 50 ريال بالإضافة إلى 10 ريالات عن كل ساعة
                      انتظار أو جزء من الساعة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      في حال كان الطلب يحتوي على عمال، سيتم خصم 25 ريال عن كل عامل في حال لم يتم
                      التحميل و50 ريال في حال البدء في عملية التحميل حتى وإن لم يتم الانتهاء منها.
                    </ListItem>
                  </List>
                  {/* <!--------------- Delay Fees Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>رسوم التأخير</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>التريلا بجميع أنواعها:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      إذا كانت الوجهة داخلية داخل المدينة وحدث تأخير تجاوز ساعتين ونصف تفرض رسوم
                      تأخير قدرها 100 ريال، كما تفرض 50 ريال لكل ساعة إضافية، إلى حد أقصى أجر مبيت.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      إذا كانت الوجهة خارجية وحدث تأخير تجاوز ثلاث ساعات تفرض رسوم قدرها 200 ريال،
                      كما تفرض رسوم إضافية 50 ريال لكل ساعة تأخير إضافية، بحد أقصى أجر مبيت.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>السقس بجميع أنواعه:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      إذا كانت الوجهة داخلية داخل المدينة وحدث تأخير تجاوز ساعتين ونصف تفرض رسوم
                      تأخير قدرها 100 ريال، كما تفرض 40 ريال لكل ساعة إضافية، إلى حد أقصى أجر مبيت.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      إذا كانت الوجهة خارجية وحدث تأخير تجاوز ثلاث ساعات تفرض رسوم قدرها 200 ريال،
                      كما تفرض رسوم إضافية 50 ريال لكل ساعة تأخير إضافية، بحد أقصى أجر مبيت.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>اللوري بجميع أنواعه:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      إذا كانت الوجهة داخلية داخل المدينة وحدث تأخير تجاوز ساعتين ونصف تفرض رسوم
                      تأخير قدرها 75 ريال، كما تفرض رسوم إضافية 25 ريال لكل ساعة تأخير إضافية، بحد
                      أقصى أجر مبيت.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      إذا كانت الوجهة خارجية وحدث تأخير تجاوز ثلاث ساعات تفرض رسوم تأخير قدرها 150
                      ريال، كما تفرض رسوم إضافية 25 ريال لكل ساعة تأخير إضافية، بحد أقصى أجر مبيت.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>الدينا بجميع أنواعها:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      إذا كانت الوجهة داخلية داخل المدينة وحدث تأخير تجاوز ساعتين تفرض رسوم تأخير
                      قدرها 50 ريال، كما تفرض رسوم إضافية قدرها 20 ريال لكل ساعة تأخير إضافية، بحد
                      أقصى أجر مبيت.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      إذا كانت الوجهة خارجية وحدث تأخير تجاوز ثلاث ساعات تفرض رسوم تأخير قدرها 75
                      ريال، كما تفرض رسوم إضافية 25 ريال لكل ساعة تأخير إضافية، بحد أقصى أجر مبيت.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>البيك آب:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      إذا حدث تأخير تجاوز ساعة ونصف تفرض رسوم تأخير قدرها 25 ريال، كما تفرض رسوم
                      إضافية 25 ريال لكل ساعة تأخير إضافية، بحد أقصى 125 ريال غير شامل الضريبة
                      المضافة.
                    </ListItem>
                  </List>
                  {/* <!--------------- Overnight Fees by Truck Type Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    رسوم المبيت حسب نوع الشاحنة
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    التريلا بجميع أنواعها (ما عدا الثلاجات مبرد وفريزر):
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      تفرض رسوم مبيت على جميع أنواع التريلا قدرها 350 ريال لليوم الأول وكل يوم إضافي
                      1000 ريال، غير شاملة رسوم الضريبة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      تفرض رسوم مبيت على جميع التريلا الثلاجات (مبرد وفريزر) قدرها 450 ريال لليوم
                      الأول وكل يوم إضافي 2000 ريال، غير شاملة رسوم الضريبة.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    السقس بجميع أنواعه (ما عدا الثلاجات مبرد وفريزر):
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      تفرض رسوم مبيت على جميع أنواع السقس قدرها 300 ريال لليوم الأول وكل يوم إضافي
                      900 ريال، غير شاملة رسوم الضريبة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      تفرض رسوم مبيت على جميع السقس الثلاجات (مبرد وفريزر) قدرها 450 ريال لليوم
                      الأول وكل يوم إضافي 1900 ريال، غير شاملة رسوم الضريبة.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    اللوري بجميع أنواعه (ما عدا الثلاجات مبرد وفريزر):
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      تفرض رسوم مبيت على جميع أنواع اللواري قدرها 250 ريال لليوم الأول وكل يوم إضافي
                      750 ريال، غير شاملة رسوم الضريبة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      تفرض رسوم مبيت على جميع اللواري الثلاجات (مبرد وفريزر) قدرها 350 ريال لليوم
                      الأول وكل يوم إضافي 1500 ريال، غير شاملة رسوم الضريبة.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    الدينا بجميع أنواعها (ما عدا الثلاجات مبرد وفريزر):
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      تفرض رسوم مبيت على جميع أنواع الدينا قدرها 150 ريال لليوم الأول وكل يوم إضافي
                      650 ريال، غير شاملة رسوم الضريبة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      تفرض رسوم مبيت على جميع الدينا الثلاجات (مبرد وفريزر) قدرها 250 ريال لليوم
                      الأول وكل يوم إضافي 1000 ريال، غير شاملة رسوم الضريبة.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>البيك آب:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      تفرض رسوم مبيت قدرها 125 ريال لليوم الأول وكل يوم إضافي 250 ريال، غير شاملة
                      رسوم الضريبة.
                    </ListItem>
                  </List>
                  {/* <!--------------- Loading and Unloading Fees in Vital Areas Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    بند رسوم التحميل والتنزيل في المناطق الحيوية
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>تعريف المناطق الحيوية:</Typography>
                    <Typography>
                      {' '}
                      المناطق الحيوية هي المواقع التي تشمل المطارات، ووسط المدن، والموانئ، والشوارع
                      الواقعة في قلب المدن الرئيسية والتي قد تتطلب تصاريح خاصة وتعطيل لمصلحة الناقل
                      وشاحنته. هذه المواقع تعتبر حساسة نظرًا للتحديات اللوجستية التي تواجه السائقين
                      عند الوصول إليها أو الخروج منها.{' '}
                    </Typography>
                  </Typography>
                  {/* <!--------------- Loading and Unloading Fees in Vital Areas Related Terms --------------------------> */}
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      الرسوم المترتبة على التحميل والتنزيل في المناطق الحيوية: <br />
                      تعريف المناطق الحيوية <br />
                      المناطق الحيوية هي المواقع التي تشمل:
                    </Typography>
                  </Typography>
                  <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      وسط المدن : مناطق وسط المدينة التي يصعب الوصول إليها أو الخروج منها بسبب
                      الزحام أو منع المرور وأنظمة الدولة. تشمل هذه المناطق الشوارع والزقاق الضيقة و
                      الشوارع والطرق الحيوية والمليئة بمحلات التجزئة والتجارية.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      المطارات: مناطق تحميل أو تنزيل البضائع داخل أو حول المطارات التي تحتاج إلى
                      تصاريح خاصة للدخول وتعطيل الناقل وشاحنته.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      الموانئ: مناطق تحميل أو تنزيل البضائع داخل أو حول الموانئ التي تتطلب تصاريح
                      خاصة للدخول أو الخروج وتعطيل الناقل وشاحنته.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      المنشآت والوزارات الحكومية: مواقع تحميل أو تنزيل البضائع داخل أو حول المنشآت
                      الحكومية أو الوزارات التي تحتاج إلى تصاريح خاصة وتعطيل الناقل وشاحنته.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      وسط الأحياء السكنية المكتملة: مناطق وسط الأحياء السكنية التي تكون مكتملة
                      البنية التحتية وتشهد حركة مرورية عالية مما يجعل الوصول إليها أو الخروج منها
                      صعبًا.
                    </ListItem>
                  </List>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      أمثلة مشابهة للمناطق الحيوية:
                    </Typography>
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>المناطق الصناعية:</Typography> قد تشمل
                      مناطق صناعية معينة حيث تكون الحركة مرورية كثيفة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        {' '}
                        الجامعات والمستشفيات الكبرى:
                      </Typography>{' '}
                      مناطق حول الجامعات أو المستشفيات الكبرى التي تحتاج إلى تصاريح خاصة وتكون ذات
                      حركة مرورية كثيفة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>المراكز التجارية الكبيرة:</Typography>{' '}
                      مناطق حول المراكز التجارية الكبيرة التي تشهد زحامًا مروريًا بشكل دائم.
                    </ListItem>
                  </List>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>إمكانية إضافة مناطق أخرى:</Typography>{' '}
                    <br />
                    <Typography>
                      {' '}
                      تحتفظ منصة شحن بالحق في إضافة مناطق أخرى إلى قائمة المناطق الحيوية بناءً على
                      تقديرها وحسب العرف السائد في السوق السعودي. العميل ملزم بدفع الرسوم المترتبة
                      على التحميل أو التنزيل في هذه المناطق وفقًا لسياسة المناطق الحيوية المحددة من
                      قبل منصة شحن وحسب حجم الشاحنة ونوعها. هذه الرسوم تضاف إلى فاتورة الطلب أو تصدر
                      كفاتورة خارجية أخرى حسب وضع الحالة والسياسة التي تتخذها منصة شحن.{' '}
                    </Typography>
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold' }}>
                    تفرض منصة شحن رسومًا إضافية على التحميل والتنزيل في المناطق الحيوية وذلك بسبب
                    الصعوبات اللوجستية والتعطيلات المحتملة للسائقين. هذه الرسوم هي كالتالي:
                  </Typography>
                  <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        {' '}
                        التريلا بجميع أنواعها (ما عدا الثلاجة):
                      </Typography>{' '}
                      رسوم إضافية: 500 ريال
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        التريلا ثلاجة (مبرد والمجمد):
                      </Typography>{' '}
                      رسوم إضافية: 700 ريال
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        ⁠السقس بجميع أنواعة (ماعدا الثلاجة)
                      </Typography>{' '}
                      رسوم إضافية: 450 ريال
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        السقس الثلاجة (المبرد والمجمد)
                      </Typography>{' '}
                      رسوم إضافية: 650 ريال
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        اللوري بجميع أنواعه (ما عدا الثلاجة)
                      </Typography>{' '}
                      رسوم إضافية: 250 ريال
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        اللوري الثلاجة (المبرد والمجمد)
                      </Typography>{' '}
                      رسوم إضافية: 300 ريال
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        الدينا بجميع أنواعها (ما عدا الثلاجة)
                      </Typography>{' '}
                      رسوم إضافية: 100 ريال
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        الدينا الثلاجة (المبرد والمجمد)
                      </Typography>{' '}
                      رسوم إضافية: 150 ريال
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>الونيت:</Typography> رسوم إضافية: 50
                      ريال
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold' }}>شروط وأحكام الرسوم:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      في حال كان موقع التحميل حيوي وموقع التنزيل حيوي، سيتم فرض الرسوم مرتين؛ رسوم
                      لكل موقع على حدة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      هذه الرسوم ستضاف إلى فاتورة الطلب نفسه أو تصدر فاتورة خارجية أخرى حسب وضع
                      الحالة والسياسة التي تتخذها منصة شحن والعميل ملزم بدفع هذه الرسوم.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      الرسوم المفروضة تشمل أي رسوم إضافية قد تترتب على التأخير أو المبيت، ويمكن أن
                      تجتمع هذه الرسوم في رحلة واحدة وعلى نفس الطلب.
                    </ListItem>
                  </List>
                  {/* <!--------------- Unpaved Roads Fees and Policy Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    رسوم وسياسة الطرق غير المعبدة
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>تعريف الطرق غير المعبدة:</Typography>
                    <Typography>
                      {' '}
                      الطرق غير المعبدة هي تلك الطرق التي لا تكون مسفلتة أو تكون وعرة أو رديئة من
                      ناحية السلامة للشاحنة والبضائع. تشمل هذه الطرق أي مسار يفتقر إلى البنية
                      التحتية الأساسية التي تضمن سلامة الشاحنات والبضائع المنقولة عليها.
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      الرسوم المترتبة على استخدام الطرق غير المعبدة:
                    </Typography>
                    <Typography>
                      {' '}
                      تفرض منصة شحن رسومًا إضافية على استخدام الطرق غير المعبدة، بناءً على المسافة
                      المقطوعة بالكيلومتر. هذه الرسوم هي كالتالي:{' '}
                    </Typography>
                  </Typography>
                  <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>التريلا بجميع أنواعها:</Typography>{' '}
                      رسوم الكيلومتر: 35 ريال
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>السقس بجميع أنواعه:</Typography> رسوم
                      الكيلومتر: 35 ريال
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>اللوري:</Typography> رسوم الكيلومتر:
                      25 ريال
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>الدينا:</Typography> رسوم الكيلومتر:
                      20 ريال
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>الونيت:</Typography> رسوم الكيلومتر:
                      15 ريال
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold' }}>شروط وأحكام الرسوم:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      يتحمل العميل أي ضرر قد يحصل للبضاعة نتيجة استخدام تلك الطرق.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يتحمل العميل مسؤولية وفواتير تعلق أو تعطل الشاحنة على الطرق الغير معبدة وأي
                      تكاليف سحب للشاحنة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يتحمل العميل أي ضرر قد يحدث لشاحنات الناقل أو ممتلكاته وتعويضة نتيجة استخدام
                      الطرق غير المعبدة.
                    </ListItem>
                  </List>
                  {/* <!--------------- Terms and Conditions of the Daily Truck Rental Service Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    شروط وأحكام خدمة الإيجار اليومي للشاحنة
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>تعريف الخدمة:</Typography>
                    <Typography>
                      {' '}
                      خدمة الإيجار اليومي هي خدمة توفرها منصة شحن للعملاء بحيث توفر لهم شاحنة مع
                      السائق لمدة تصل إلى 8 ساعات خلال اليوم. يمكن للعميل الاستفادة من الشاحنة خلال
                      هذا الوقت للتحميل والتنزيل من عدة نقاط. يمكن للعميل تتبع السائق من خلال
                      التطبيق.{' '}
                    </Typography>
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    تفاصيل الخدمة ورسوم الإضافية
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      تفرض رسوم إضافية على العميل في حال تجاوز الـ 8 ساعات بحسب نوع وحجم الشاحنة وهي
                      كالتالي: <br />
                      <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          التريلا والسقس (ما عدا الثلاجة): 119 ريال لكل ساعة إضافية، بحد أقصى رسوم
                          إيجار يوم كامل.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          التريلا والسقس الثلاجة (مبرد/مجمد): 169 ريال لكل ساعة إضافية للمبرد و 188
                          ريال للمجمد، بحد أقصى رسوم إيجار يوم كامل.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          اللوري (ما عدا الثلاجة): 88 ريال لكل ساعة إضافية، بحد أقصى رسوم إيجار يوم
                          كامل.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          اللوري الثلاجة (مبرد/مجمد): 110 ريال لكل ساعة إضافية للمبرد و 125 ريال
                          للمجمد ، بحد أقصى رسوم إيجار يوم كامل.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          الدينا (ما عدا الثلاجة): 50 ريال لكل ساعة إضافية، بحد أقصى رسوم إيجار يوم
                          كامل.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          الدينا الثلاجة (مبرد/مجمد): 94 ريال لكل ساعة إضافية للمبرد و 100 ريال
                          للمجمد ، بحد أقصى رسوم إيجار يوم كامل.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          البك اب: 37 ريال لكل ساعة إضافية، بحد أقصى رسوم إيجار يوم كامل.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      رسوم إيجار اليوم كامل: <br />
                      <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          التريلا والسقس (ما عدا الثلاجة): 1000 ريال
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          التريلا والسقس (ثلاجة مبرد ومجمد): 1360 ريال للمبرد و 1500 للمجمد.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          اللوري (ما عدا الثلاجة): 600 ريال
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          اللوري (ثلاجة مبرد ومجمد): 875 ريال للمبرد و 950 للمجمد.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          الدينا (ما عدا الثلاجة): 500 ريال
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          الدينا (ثلاجة مبرد ومجمد): 750 ريال للمبرد و 800 للمجمد.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>البك اب: 400 ريال</ListItem>
                      </List>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    شروط وأحكام إضافية تخص الإيجار اليومي
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      تبدأ الرحلة فور وصول السائق لموقع العميل.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      تحسب رسوم التأخير كحد أقصى إيجار اليوم بالإضافة إلى رسوم المبيت في حال تخزين
                      البضاعة في مركبة السائق لليوم التالي.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      مدة الإيجار اليومي تكون لمدة 16 ساعة أو حتى الساعة 12 منتصف الليل، أيهما يأتي
                      أولاً. في حال تجاوز العميل هذه المدة، يتم احتساب رسوم مبيت إضافيه على رسوم
                      الايجار والتأخير.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      لا يمكن ترحيل أي مدة غير مستخدمة إلى يوم آخر.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      في حال تعطل الشاحنة، تلتزم منصة شحن بتوفير شاحنة بديلة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يتم توجيه السائق عبر التواصل المباشر مع السائق والذي تزودك به منصة شحن. يمكن
                      للعميل تتبع السائق ومعرفة عنوانه من خلال التطبيق ولكن لا يمكن إرسال المواقع له
                      من خلال التطبيق. يمكن للعميل إرسالها مباشرة على رقم السائق.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يتحمل العميل المسؤولية عن أي رسوم أو مخالفات ناتجة عن سوء التحميل أو عدم اتباع
                      الأنظمة في مسألة الوزن المسموح للتحميل بحسب أنظمة المرور والجهات الحكومية.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب تزويد منصة شحن بمعلومات الرحلة عبر البريد الإلكتروني care@shahen-sa.com
                      وذلك لإبلاغ شركة التأمين بالرحلة وتغطيتها.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      جميع الشروط والأحكام الأخرى المذكورة على منصة شحن تنطبق على خدمة الإيجار
                      اليومي.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>مسؤوليات العميل</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      الالتزام بالسياسات والشروط والأحكام المعتمدة من قبل منصة شحن.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      الالتزام بتوجيه السائق بشكل صحيح وتقديم المعلومات اللازمة لضمان وصول الشاحنة
                      إلى النقاط المحددة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      دفع جميع الرسوم المستحقة في الوقت المحدد وفقًا لشروط وأحكام منصة شحن.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      في حال تجاوز العميل عدد الساعات المحدد للشاحنة، تطبق عليه رسوم التأخير حسب نوع
                      وحجم الشاحنة والمذكورة في شروط وأحكام منصة شحن.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      عدم تأجير الشاحنة للغير إلا بموافقة خطية من منصة شحن.
                    </ListItem>
                  </List>
                  {/* <!--------------- Obligations of the Parties Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    شروط وأحكام خدمة الباقات الشهرية
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>تعريف الخدمة</Typography>
                  <Typography>
                    باقة الرحلات الشهرية هي خدمة تتيح للعميل إمكانية حجز عدد محدد من الرحلات لشهر/٣٠
                    يوم لنوع محدد من الشاحنات لنقل منتجاته داخل مدينة محددة بأسعار ثابتة ومخفضة تشمل
                    التأمين على البضاعة واستخدام رصيد الرحلات وجدولة طلباته لاحقاً خلال ٣٠ يوم. يمكن
                    للعميل تتبع الرحلات، بالإضافة إلى خدمة توثيق التحميل والتسليم بالصور.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>نطاق الخدمة</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      خدمة باقة تأجير الشاحنات الشهرية محدودة داخل المدينة نفسها وبحد أقصى 60
                      كيلومتر للرحلة الواحدة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        مجموع المدة المسموحة للتحميل والتنزيل وفقًا لنوع الشاحنة:
                      </Typography>
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>التريلا والسقس: 2.5 ساعة.</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>اللوري: 2 ساعة.</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>الدينا: 1.5 ساعة.</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>البك آب: 1 ساعة.</ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      في حال تجاوز وقت الانتظار المدة المسموح بها، يتم فرض رسوم تأخير حسب سياسة منصة
                      شحن.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      كل رحلة تتضمن نقطة تحميل واحدة ونقطة تسليم واحدة فقط.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>التزامات الطرفين</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      لا يمكن تعديل أو إلغاء الطلب بعد التأكيد، إلا في حالات استثنائية مثل عدم
                      استخدام الرصيد نهائيًا وعدم وجود طلبات ملغاة أو حركة في العقد.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      صلاحية الباقة لمدة 30 يومًا من تاريخ الشراء.
                    </ListItem>
                  </List>
                  {/* <!--------------- Cancellation and Modification Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>التعامل مع السائقين</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      يُحظر التعامل مع السائقين خارج المنصة دون إذن خطي من منصة شحن.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      التعاملات غير المصرح بها تؤدي إلى إلغاء العقد وخصم القيمة المتبقية من العقد.
                    </ListItem>
                  </List>
                  {/* <!--------------- Interaction with Drivers Related Terms --------------------------> */}
                  {/* <!--------------- General Clauses Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>البنود العامة</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      تحتفظ منصة شحن بحق تعديل هذه الشروط والأحكام.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      في حال عدم توفر نوع الشاحنة المطلوب، يحق لمنصة شحن إرسال شاحنة أخرى بنفس الحجم
                      أو أكبر، ما لم يكن المنتج المنقول يتطلب شاحنة بمواصفات خاصة كالتبريد.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يحق لمنصة شحن، عندما يكون موقع التحميل غير جاهز للتحميل بسبب تزاحم الشاحنات
                      التي تنتظر مسبقًا للتحميل أو بسبب عدم جاهزية البضاعة، أن يسحب الشاحنة ويرسلها
                      لطلب آخر ولعميل آخر، مع إرسال شاحنة أخرى بدلًا عنها. ولا يتحمل المؤجر أية
                      تبعات بسبب تأخر وصول الشاحنة الأخرى البديلة.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يتحمل العميل تكلفة التأخير أو المبيت وفقًا لما هو موضح في شروط استخدام المنصة
                      ووقت التأخير المقدر للباقات الشهرية.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      مدة استخدام الرصيد هي 30 يومًا ولا يمكن ترحيل الرصيد المتبقي بعد انتهاء الفترة
                      لأي سبب كان.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      السائق نفسه سيقوم بتنفيذ رحلات العميل إلا إذا زاد عدد الرحلات المشتراة من
                      العميل في الشهر عن: <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>التريلا: 24 رحلة.</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>السقس:24 رحلة.</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>اللوري: 26 رحلة.</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>الدينا: 52 رحلة.</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>البك آب: 60 رحلة.</ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      إذا احتاج العميل لاستخدام عدد أكبر من الرحلات في يوم واحد، سيتم تعيين سائق
                      إضافي حسب الجدول التالي:
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>التريلا: أكثر من رحلة.</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>السقس: أكثر من رحلة.</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>اللوري: أكثر من رحلتين.</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          الدينا: أكثر من ثلاث رحلات.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          البك آب: أكثر من خمس رحلات.
                        </ListItem>
                      </List>
                    </ListItem>
                  </List>
                  {/* <!--------------- Terms and Conditions for Shahen's Monthly Rental Service Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    شروط وأحكام خدمة الإيجار الشهري لمنصة شحن
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>تعريف الخدمة:</Typography>
                    <Typography>
                      {' '}
                      خدمة الإيجار الشهري لمنصة شحن تتيح للعملاء تأجير شاحنات بسائق لمدة 26 يومًا في
                      الشهر، مع 8 ساعات عمل يوميًا. تشمل الأسعار المحددة في التطبيق التأمين على
                      البضائع بشرط الإفصاح عن قيمتها ونوع الحمولة أثناء التعاقد. يتم إبلاغ منصة شحن
                      بالرحلات عبر البريد الإلكتروني care@shahen-sa.com لغرض إبلاغ شركة التأمين
                      وتغطية الرحلة.
                    </Typography>
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    شروط وأحكام الإيجار الشهري
                  </Typography>
                  <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}> مدة الإيجار والساعات</Typography>
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          مدة الإيجار الشهري هي 26 يومًا في الشهر، مع 8 ساعات عمل يوميًا.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          في حال تجاوز العميل عدد الساعات المحدد، تطبق رسوم التأخير حسب نوع وحجم
                          الشاحنة والمذكورة في شروط وأحكام منصة شحن.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          في حال تجاوزة مدة الرحلة لليوم الواحد أكثر من 16 ساعة أو بلوغ الوقت للساعة
                          12:00 مساء يتم فرض رسوم مبيت أخرى إضافيه غير رسوم التأخير والساعات
                          الاضافية.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}> الإبلاغ عن الرحلات</Typography>
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          يجب على العميل تزويد منصة شحن بمعلومات الرحلة عبر البريد الإلكتروني
                          care@shahen-sa.com قبل كل رحلة لضمان تغطية التأمين.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}> الرسوم والتكاليف</Typography>
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          تطبق جميع الرسوم الأخرى مثل رسوم التأخير والمبيت وفقًا لشروط وأحكام منصة
                          شحن.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          لا يُسمح بتخزين البضائع في الشاحنات والعميل مسؤول عن أي ضرر قد يحصل
                          للبضاعة.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          رسوم الساعة الإضافية غير شاملة الضريبة المضافة هي كما يلي: <br />
                          <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                            <ListItem sx={{ display: 'list-item' }}>
                              التريلا والسقس (ما عدا الثلاجة) - 119 ريال لكل ساعة إضافية، حد أقصى
                              رسوم إيجار يوم كامل.
                            </ListItem>
                            <ListItem sx={{ display: 'list-item' }}>
                              التريلا والسقس الثلاجة (مبرد مجمد) - 169 ريال لكل ساعة إضافية، حد أقصى
                              رسوم إيجار يوم كامل.
                            </ListItem>
                            <ListItem sx={{ display: 'list-item' }}>
                              اللوري (ما عدا الثلاجة) - 88 ريال لكل ساعة إضافية، حد أقصى رسوم إيجار
                              يوم كامل.
                            </ListItem>
                            <ListItem sx={{ display: 'list-item' }}>
                              اللوري الثلاجة (مبرد مجمد) - 100 ريال لكل ساعة إضافية، حد أقصى رسوم
                              إيجار يوم كامل.
                            </ListItem>
                            <ListItem sx={{ display: 'list-item' }}>
                              الدينا (ما عدا الثلاجة) - 50 ريال لكل ساعة إضافية، حد أقصى رسوم إيجار
                              يوم كامل.
                            </ListItem>
                            <ListItem sx={{ display: 'list-item' }}>
                              الدينا الثلاجة (مبرد مجمد) - 94 ريال لكل ساعة إضافية، حد أقصى رسوم
                              إيجار يوم كامل.
                            </ListItem>
                            <ListItem sx={{ display: 'list-item' }}>
                              البك اب - 37 ريال لكل ساعة إضافية، حد أقصى رسوم إيجار يوم كامل.
                            </ListItem>
                          </List>
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>التأجير وإعادة الاستخدام</Typography>
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          لا يُسمح للعميل بتأجير الشاحنة للغير إلا بموافقة خطية من منصة شحن.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          لا يمكن ترحيل أي مدة غير مستخدمة لشهر آخر.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          لا يمكن للعميل إلغاء عقد الإيجار بعد تعيين سائق على العقد حتى وإن لم يتم
                          الاستفادة من الشاحنة أو العقد.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>نقل الشاحنة والتوجيه</Typography>{' '}
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          لا يمكن نقل الشاحنة للعمل في مدينة أخرى غير المحددة عند رفع الطلب.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          يتم توجيه السائق عبر التواصل المباشر مع السائق الذي تزودك به منصة شحن.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          يمكن للعميل تتبع السائق ومعرفة عنوانه من خلال التطبيق، لكن لا يمكن إرسال
                          المواقع له من خلال التطبيق، بل يمكن إرسالها مباشرة على رقم السائق.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>التعطل والاستبدال</Typography>
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          في حال تعطل الشاحنة، تلتزم منصة شحن بتوفير شاحنة بديلة.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          يمكن لمنصة شحن استبدال السائق وتغييره أثناء سريان العقد.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}> وضع الشعارات</Typography>
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          يمكن للعميل وضع شعاراته على الشاحنة إذا كانت مدة الإيجار تزيد عن 6 أشهر
                          وعلى حسابه الخاص.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          في حال كانت مدة الإيجار سنة أو أكثر، يتم وضع الشعار وتصميمه على حساب منصة
                          شحن.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>مدة الرحلة واحتساب الوقت</Typography>{' '}
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          تبدأ مدة الرحلة فور وصول السائق إلى موقع العميل، وتُحسب زحمة الطرقات
                          والتأخر ضمن ساعات العمل للشاحنة.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          للعميل الحق في استخدام الشاحنة في التحميل والتنزيل من عدة نقاط.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          للشاحنات التي يشملها منع التنقل في المدن، وفي حالات صعوبة توجيه الشاحنة
                          بعد التحميل أو التنزيل، يتم احتساب أيام العمل على أساس 26 يومًا من أول يوم
                          يبدأ فيه العقد. يتم احتساب أي يوم إضافي بقيمة الإيجار اليومي بحسب نوع وحجم
                          الشاحنة "ينصح بمراجعة قيمة الاجار اليومي المذكورة في شروط وأحكام منصة شحن"
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>مسؤوليات العميل</Typography>
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          يتحمل العميل دفع أي رسوم ومخالفات تنتج عن سوء التحميل أو عدم اتباع الأنظمة
                          المتعلقة بالوزن المسموح للتحميل حسب أنظمة المرور والجهات الحكومية وأي
                          تكاليف يكون العميل سببها.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          يجب على العميل قراءة وفهم جميع الشروط والأحكام الأخرى المطبقة والمذكورة
                          على منصة شحن.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography sx={{ fontWeight: 'bold' }}>التسعير:</Typography>
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          {' '}
                          الأسعار محددة في التطبيق وفقًا لسياسة منصة شحن، وتحتفظ منصة شحن بحق تعديل
                          الأسعار في أي وقت بناءً على وضع السوق والظروف القاهرة الخارجة عن إرادة
                          منصة شحن، مثل ارتفاع أسعار الوقود أو القرارات الحكومية.
                        </ListItem>
                      </List>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>ملاحظات مهمة</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      جميع الشروط والأحكام المذكورة أعلاه تُعد ملزمة بمجرد استخدام العميل لخدمات
                      منصة شحن.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      يجب على العميل الالتزام بجميع التعليمات والإرشادات المقدمة من منصة شحن لضمان
                      سير العملية بسلاسة وكفاءة.
                    </ListItem>
                  </List>
                  {/* <!--------------- Dispute Resolution Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>حل النزاع</Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>تسوية النزاع ودياً:</Typography>
                    <Typography>
                      {' '}
                      في حالة نشوء أي نزاع أو خلاف بين الأطراف بشأن تنفيذ أو تفسير هذه الاتفاقية،
                      يجب على الأطراف بذل جهودهم القصوى لتسوية النزاع وديًا من خلال التفاوض المباشر.
                      إذا لم يتم التوصل إلى تسوية ودية خلال خمسة عشر (15) يومًا من بدء المفاوضات،
                      يتم إحالة النزاع إلى التحكيم وفقًا للشروط المحددة أدناه.
                    </Typography>
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>حل النزاع بالتحكيم</Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>اتفاقية التحكيم:</Typography>
                    <Typography>
                      {' '}
                      توافق الأطراف على أن أي نزاع أو خلاف ينشأ عن أو يتعلق بهذا الاتفاق، بما في ذلك
                      أي مسائل تتعلق بتفسيره أو تنفيذه، سيتم حله نهائيًا عن طريق التحكيم وفقًا
                      للقواعد المحددة أدناه.
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>القواعد والإجراءات:</Typography>
                    <Typography>
                      {' '}
                      يتم إجراء التحكيم وفقًا لقواعد المركز السعودي للتحكيم التجاري.
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>اختيار المحكمين:</Typography>
                    <Typography>
                      {' '}
                      يتعين على كل طرف تعيين محكم واحد، ويتعين على المحكمين المعينين تعيين محكم ثالث
                      ليكون رئيس لجنة التحكيم. إذا لم يتمكن المحكمون من الاتفاق على محكم ثالث خلال
                      ثلاثين (30) يومًا، فسيتم تعيين المحكم الثالث من قبل مركز التحكيم المختار.
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>مكان التحكيم:</Typography>
                    <Typography>
                      {' '}
                      يتم إجراء التحكيم في مدينة الرياض، المملكة العربية السعودية.
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>لغة التحكيم:</Typography>
                    <Typography>
                      {' '}
                      تكون لغة التحكيم هي اللغة العربية، ما لم يتفق الطرفان على غير ذلك.{' '}
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>القانون الواجب التطبيق:</Typography>
                    <Typography>
                      {' '}
                      يخضع هذا الاتفاق وأي نزاع ينشأ عنه لأحكام القوانين والأنظمة المعمول بها في
                      المملكة العربية السعودية.
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>التكاليف والرسوم:</Typography>
                    <Typography>
                      {' '}
                      يتحمل الطرف الخاسر جميع تكاليف التحكيم بما في ذلك أتعاب المحكمين والرسوم
                      الإدارية والمصاريف القانونية. يحق لمنصة شحن أن تطالب الطرف الآخر بسداد هذه
                      التكاليف فور صدور الحكم التحكيمي.
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>السرية:</Typography>
                    <Typography>
                      {' '}
                      تظل إجراءات التحكيم وجميع المستندات والمعلومات المتعلقة بها سرية ولا يجوز
                      الكشف عنها لأي طرف ثالث دون موافقة خطية مسبقة من جميع الأطراف.{' '}
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>إلزامية الحكم:</Typography>
                    <Typography>
                      {' '}
                      يكون الحكم الصادر عن هيئة التحكيم نهائيًا وملزمًا للطرفين، ويجوز تنفيذه في أي
                      محكمة ذات اختصاص قضائي.
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>حماية حقوق منصة شحن:</Typography>
                    <Typography>
                      {' '}
                      تحتفظ منصة شحن بالحق في اتخاذ أي إجراء قانوني ضروري لحماية حقوقها ومصالحها،
                      بما في ذلك إيقاف تسليم الحمولة حتى يتم دفع الرسوم المستحقة، ويقر العميل
                      بمسؤوليته عن أي تأخير أو ضرر قد ينشأ نتيجة التأخير في دفع الرسوم.
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>الإقرار والتعاون:</Typography>
                    <Typography>
                      {' '}
                      يقر العميل بمسؤوليته عن التعاون الكامل مع منصة شحن في أي إجراءات قانونية أو
                      تحكيمية، بما في ذلك تقديم جميع المستندات والمعلومات اللازمة لدعم مطالبات
                      المنصة والدفاع عنها. يتعهد العميل بدفع الضرر عن منصة شحن وموظفيها وممثليها
                      وعدم مقاضاتهم بشكل مباشر.{' '}
                    </Typography>
                  </Typography>
                  {/* <!--------------- Pricing Method Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>طريقة التسعير</Typography>
                  <Typography>
                    يتم تحديد سعر خدمة النقل في منصة شحن عبر احتساب المسافة من نقطة التحميل وحتى
                    الوجهة النهائية تلقائيًا. بالنسبة لبعض الخدمات مثل الإيجار الشهري، وباقة
                    الرحلات، والإيجار اليومي وبعض الخدمات الأخرى، يتم تحديد التسعير وفقًا لسياسة
                    منصة شحن. تحتفظ منصة شحن بالحق في تعديل الأسعار في أي وقت وبحسب وضع السوق
                    والظروف، بما في ذلك الحالات القاهرة الخارجة عن إرادة منصة شحن مثل ارتفاع أسعار
                    الوقود أو القرارات الحكومية، على سبيل المثال لا الحصر. يسري هذا التعديل في
                    الأسعار على جميع العقود، بما في ذلك العقود المبرمة مع العملاء.
                  </Typography>
                  {/* <!--------------- Invalidity of One or More Provisions Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>بطلان حكم أو أكثر</Typography>
                  <Typography>
                    لا يؤثر بطلان أي حكم من أحكام شروط مقدم الخدمة الماثلة على صحة باقي الأحكام
                    الأخرى الواردة فيها. في حالة وجود أي حكم باطل في شروط مقدم الخدمة الماثلة أو
                    وجود حكم غير مقبول في ظروف معينة وفقًا لمعايير المعقولية والعدالة وإلى هذا المدى
                    فقط، يُعمل بدلاً منه بين الطرفين بحكم يكون مقبولاً مراعاةً لجميع الظروف ويتوافق
                    مع أحكام الشرط الباطل قدر الإمكان، مع مراعاة محتوى شروط مقدم الخدمة الماثلة
                    وغرضها.
                  </Typography>
                  {/* <!--------------- Termination Clause Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>بند إنهاء الاتفاقية</Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>إنهاء الاتفاقية:</Typography>
                    <Typography>
                      {' '}
                      يمكن لمنصة شحن إنهاء الاتفاقية مع أي عميل في أي وقت ولأي سبب، مع إشعار مسبق
                      للعميل.
                    </Typography>
                    <br />
                    <Typography>
                      {' '}
                      يحق للعميل إنهاء الاتفاقية مع منصة شحن بإشعار كتابي مسبق، على أن يكون قد أوفى
                      بجميع الالتزامات المالية وغير المالية المستحقة.{' '}
                    </Typography>
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>مدة العقد وإنهاؤه</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      يكون العقد المُبرم بينك وبين “منصة شحن” غير محدد المدة. يحق لك إنهاء العقد في
                      أي وقت بحذف التطبيق المثبت على هاتفك الذكي نهائيًا، مما يعطل استخدامك للتطبيق
                      والخدمة. يمكنك أيضًا إغلاق حسابك في أي وقت. يحق لـ”منصة شحن” إنهاء العقد بأثر
                      فوري في أي وقت (بتعطيل استخدامك للتطبيق والخدمة) في حالة قيامك بأي مما يلي:
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      انتهاك أو خرق أي شرط من شروط مقدم الخدمة،
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      إذا رأت “منصة شحن” أنك تسيء استخدام التطبيق أو الخدمة. إن “منصة شحن” غير ملزمة
                      بإرسال سابق إخطار بإنهاء العقد. بالنسبة للعملاء الذين لديهم عقود مبرمة مع منصة
                      شحن، لا يحق لهم فسخ العقد وهم ملزمون بالامتثال لبنود العقد وجزاءات فسخ العقد
                      وفترة الإشعار المحددة في ذلك العقد. تنطبق هذه الشروط على العقود التي يتم
                      إبرامها بالاتفاق المباشر والمحددة لشركة معينة. بالنسبة للعملاء الذين لا يملكون
                      عقودًا مبرمة مسبقًا ويستخدمون خدمات منصة شحن مباشرة بعد التسجيل، تعتبر الشروط
                      والأحكام بمثابة العقد. يمكن لهؤلاء العملاء إنهاء التعامل بحذف التطبيق ووقف
                      الاستخدام فورًا، ما لم تكن هناك شروط أو جزاءات محددة في عقد أبرم باتفاق سابق.
                    </ListItem>
                  </List>
                  {/* <!--------------- Acknowledgment and Undertaking Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>الإقرار والتعهد</Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>إقرار العميل:</Typography>
                    <Typography>
                      {' '}
                      أقرّ أنا، العميل/المفوض المستخدم لمنصة شحن أو أي منصة تابعة لها، بأنني قرأت
                      وفهمت جميع شروط وأحكام استخدام المنصة، وأوافق على الالتزام بها بشكل كامل.
                      أتعهد بتقديم معلومات صحيحة ودقيقة عند استخدام المنصة وأتحمل المسؤولية الكاملة
                      عن أي أخطاء أو إهمال قد ينتج عن تقديم معلومات غير صحيحة أو مضللة.
                    </Typography>{' '}
                    <br />
                    <Typography>
                      {' '}
                      إنك تقر بتحملك المسؤولية منفرداً عن خصوصية الخدمات، وتكون مسؤولاً منفرداً عن
                      استخدامها من قبل أي شخص آخر باستخدام حسابك و/أو اسم المستخدم أو كلمة المرور أو
                      مسوغات الوصول الخاصة بك. كما أنك توافق على إخطار “منصة شحن” إذا أصبحت على علم
                      بأي خسارة، أو سرقة، أو استخدام غير مصرح به لأي كلمة مرور، أو اسم مستخدم أو
                      عنوان بروتوكول الإنترنت (IP)، أو غير ذلك من أساليب الوصول إلى الخدمات.{' '}
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>التعهد بدفع الرسوم:</Typography>
                    <Typography>
                      {' '}
                      أتعهد بدفع جميع الرسوم المستحقة والمرتبطة بخدمات منصة شحن، بما في ذلك رسوم
                      الإلغاء، رسوم التأخير، رسوم المبيت، رسوم الطرق غير المعبدة، ورسوم المناطق
                      الحيوية، وأقرّ بأن هذه الرسوم قد تُضاف إلى فاتورة الطلب أو تصدر كفاتورة خارجية
                      أخرى حسب سياسة المنصة. أقرّ أيضًا بعدم التفاوض بشأن هذه الرسوم أو تأخير سدادها
                      وأوافق على أن للمنصة الحق في اتخاذ الإجراءات المناسبة لضمان سدادها، بما في ذلك
                      إيقاف تسليم الحمولة.
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      التعاون في التحقيقات والمطالبات:
                    </Typography>
                    <Typography>
                      {' '}
                      أتعهد بالتعاون الكامل مع منصة شحن في جميع التحقيقات المتعلقة بأي مطالبة أو
                      نزاع، وتقديم جميع المستندات والمعلومات المطلوبة لدعم التحقيق أو المطالبة.
                      أتعهد بدفع الضرر عن منصة شحن وموظفيها وممثليها وعدم مقاضاتهم بشكل مباشر عن أي
                      ضرر أو خسارة قد تنشأ نتيجة استخدام خدمات المنصة.{' '}
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>إخلاء المسؤولية:</Typography>
                    <Typography>
                      {' '}
                      أقرّ بأن منصة شحن ليست مسؤولة عن أي أضرار مباشرة أو غير مباشرة أو تبعية أو
                      خاصة أو فقدان الأرباح التي قد تنشأ عن استخدام خدمات المنصة، وأوافق على أن دور
                      المنصة هو دور توجيه مركبات نقل البضائع فقط بيني وبين الناقل. أقرّ بأنني لن
                      أقوم بمقاضاة منصة شحن أو موظفيها أو مالكيها بشأن أي مطالبة تتعلق بالخدمات
                      المقدمة.{' '}
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>الامتثال للقوانين والأنظمة:</Typography>
                    <Typography>
                      {' '}
                      أتعهد بالامتثال لجميع القوانين والأنظمة المعمول بها في المملكة العربية
                      السعودية، وأتحمل المسؤولية الكاملة عن أي مخالفات أو انتهاكات قد تحدث نتيجة
                      استخدام خدمات منصة شحن. أقرّ بأن أي نزاع ينشأ سيتم حله وفقًا لأحكام القوانين
                      السعودية وفي المحاكم السعودية المختصة في مدينة الرياض.
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>سرية المعلومات:</Typography>
                    <Typography>
                      {' '}
                      أقرّ بأنني سأحافظ على سرية جميع المعلومات التي أحصل عليها من خلال استخدام
                      المنصة، وأتعهد بعدم الكشف عن أي معلومات سرية لأي طرف ثالث دون موافقة خطية
                      مسبقة من منصة شحن.
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>القبول والتفويض:</Typography>
                    <Typography>
                      {' '}
                      أقرّ بأنني مخول بالتوقيع والالتزام نيابةً عن الشركة أو المؤسسة التي أمثلها،
                      وأتحمل المسؤولية الكاملة عن التزاماتي والتزامات الشركة أو المؤسسة التي أمثلها
                      بموجب هذه الشروط والأحكام.{' '}
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>التحديثات والتعديلات:</Typography>
                    <Typography>
                      {' '}
                      أتعهد بمراجعة الشروط والأحكام بشكل دوري وأوافق على أن منصة شحن تحتفظ بالحق في
                      تعديل هذه الشروط والأحكام في أي وقت، وسيتم نشر التعديلات على الموقع الإلكتروني
                      للمنصة. يعتبر استمراري في استخدام الخدمات بعد نشر التعديلات موافقة مني على
                      الالتزام بالشروط المعدلة.{' '}
                    </Typography>
                  </Typography>
                  <Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>الإقرار بالتعويض:</Typography>
                    <Typography>
                      {' '}
                      أتعهد بدفع جميع التعويضات المتعلقة بأي خسارة أو ضرر ينشأ عن استخدامي للمنصة،
                      وأقرّ بأنني سأتحمل التكاليف والمصروفات المتعلقة بأي دعوى يقيمها الغير ضد منصة
                      شحن نتيجة لأي خرق من جانبي لأي من شروط الاستخدام الماثلة.{' '}
                    </Typography>
                  </Typography>
                  <br />
                  <Typography>
                    بهذا أقرّ وأتعهد بالالتزام الكامل بجميع الشروط والأحكام الخاصة باستخدام منصة
                    شحن، وأتحمل المسؤولية الكاملة عن أي انتهاك أو خرق لهذه الشروط.
                  </Typography>
                  <br />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
